// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-09T16:39:00.434Z
// Property: Fairways at Feather Sound (ID: 5641831400341504)
// Collections: 13 amenities, 5 floorplans (live), 26 photos, 82 POIs, 4 reviews, 5 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5641831400341504",
  "property_external_id": "4680436",
  "property_zillow_url": "https://www.zillow.com/apartments/clearwater-fl/fairways-at-feather-sound/5ZmQDX/",
  "property_apartments_url": "https://www.apartments.com/fairways-at-feather-sound-clearwater-fl/hvd3r71",
  "property_google_business_url": "https://www.google.com/maps/place/Fairways+at+Feather+Sound/@27.8963774,-82.6706773,15z/data=!4m5!3m4!1s0x0:0x7f80ae4f3bc56dd3!8m2!3d27.8963792!4d-82.6707353",
  "property_linkedin_url": null,
  "property_hubspot_id": "8443889464",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "fairways-at-feather-sound",
  "property_name": "Fairways at Feather Sound",
  "property_website_url": "https://www.fairwaysatfeathersound.com/",
  "property_domain": "https://www.fairwaysatfeathersound.com/",
  "property_address": "13621 Feather Sound Cir E",
  "property_full_address": "13621 Feather Sound Cir E, Clearwater, FL 33762",
  "property_address_1": "13621 Feather Sound Cir E",
  "property_address_2": null,
  "property_address_city": "Clearwater",
  "property_address_state": "FL",
  "property_address_zip_full": "33762-3384",
  "property_address_zip": "33762",
  "property_address_country": "US",
  "property_address_county": "Pinellas County",
  "property_neighborhood_address": "Feather Sound",
  "property_address_latitude": "27.8971098",
  "property_address_longitude": "-82.6701157",
  "property_email": "fairways@alapts.com",
  "property_phone": "(727) 573-4601",
  "property_call_tracking_phone": "727-291-9952",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Carefree Clearwater living in a lakeside Feather Sound setting.</strong> Explore comfortable one- and two-bedroom <a href=\"/floor-plans\">floor plans</a> surrounded by lakes, walking trails, tropical landscaping, and resort-style spaces—then <a href=\"/schedule-a-tour\">schedule a tour</a> to see Fairways at Feather Sound in person.</p>",
  "property_long_description": "<p><strong>Carefree Clearwater living meets a lakeside Feather Sound setting.</strong> At Fairways at Feather Sound, you can choose a comfortable one- or two-bedroom apartment surrounded by two community lakes, walking trails, tropical landscaping, and everyday resort-style amenities. Spend time by the heated pool and sundeck, unwind in the hot tub, work out in the fitness center, play tennis, or enjoy the clubhouse, beverage bar, grills, picnic areas, and onsite dog park.</p><p>Inside, select homes bring together modern kitchens, stainless steel appliances, quartz countertops, washer/dryer convenience, walk-in closets, ceiling fans, fireplaces, lake views, and first- or second-floor options. Explore current <a href=\"/floor-plans\">floor plans</a> and <a href=\"/amenities\">amenities</a> to find the layout and features that fit your day.</p><p>Just off I-275 near Feather Sound Country Club, you’re close to Ulmerton Road dining and shopping, Carillon and Echelon City Center, Topgolf, St. Pete-Clearwater International Airport, and connections across Tampa Bay—from downtown St. Petersburg to Clearwater’s Gulf Coast beaches.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019d02ef-4b5d-705a-9a8f-610a8ef5b9d4.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style outdoor swimming pool with lounge chairs and umbrellas, overlooking a lake.",
    "public_id": "019d02ef-4b5d-705a-9a8f-610a8ef5b9d4",
    "storage_key": "property/5641831400341504/019d02ef-4b5d-705a-9a8f-610a8ef5b9d4.webp",
    "width": 1240,
    "height": 829
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "288",
  "property_year_built": "1986",
  "property_year_renovated": "2021",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.56944444444444",
  "property_admin_fee": "250",
  "property_application_fee": "85",
  "property_fees_deposit_info": "Administrative Fee $250\nApplication Fee $85\nApplication Approval Fee Starting at $399\nNon-Refundable Pet Fee $350 for 1st Pet, Additionally $250 for 2nd Pet\nMonthly Pet Rent $35 / pet",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $350 for your 1st pet and an additional $250 for your 2nd pet, with a monthly pet rent of $35 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $350 for your 1st pet and an additional $250 for your 2nd pet, with a monthly pet rent of $35 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8020538.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://fairwaysatfeathersound.loftliving.com/login",
  "property_apply_now_url": "https://8020538.onlineleasing.realpage.com",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019e6a93-70f2-7518-8ba6-2c1932abfe81.webp",
  "property_primary_logo_media": {
    "alt_text": "Fairways at Feather Sound logo",
    "public_id": "019e6a93-70f2-7518-8ba6-2c1932abfe81",
    "storage_key": "property/5641831400341504/019e6a93-70f2-7518-8ba6-2c1932abfe81.webp",
    "width": 1621,
    "height": 394
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019e6a93-70e7-735a-8446-24b6511e7598.webp",
  "property_secondary_logo_media": {
    "alt_text": "Fairways logo",
    "public_id": "019e6a93-70e7-735a-8446-24b6511e7598",
    "storage_key": "property/5641831400341504/019e6a93-70e7-735a-8446-24b6511e7598.webp",
    "width": 1621,
    "height": 394
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019e6a93-7159-71fe-8701-d57a6b9d3a48.webp",
  "property_icon_media": {
    "alt_text": "Fairways logo",
    "public_id": "019e6a93-7159-71fe-8701-d57a6b9d3a48",
    "storage_key": "property/5641831400341504/019e6a93-7159-71fe-8701-d57a6b9d3a48.webp",
    "width": 1000,
    "height": 1000
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019e6a93-7159-71fe-8701-d57a6b9d3a48.webp",
  "property_fav_icon_media": {
    "alt_text": "Fairways logo",
    "public_id": "019e6a93-7159-71fe-8701-d57a6b9d3a48",
    "storage_key": "property/5641831400341504/019e6a93-7159-71fe-8701-d57a6b9d3a48.webp",
    "width": 1000,
    "height": 1000
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f429c-b5d3-75b1-a616-9255c9a4f98c.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019f429c-b5d3-75b1-a616-9255c9a4f98c",
    "storage_key": "property/5641831400341504/019f429c-b5d3-75b1-a616-9255c9a4f98c.webp",
    "width": 1280,
    "height": 311
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f429c-9f3b-7433-84c8-4b8cf6af60df.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019f429c-9f3b-7433-84c8-4b8cf6af60df",
    "storage_key": "property/5641831400341504/019f429c-9f3b-7433-84c8-4b8cf6af60df.webp",
    "width": 1280,
    "height": 311
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#6ba2b9",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": "#ffffff",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "608 - 1060",
  "property_sqft_min": "608",
  "property_sqft_max": "1060",
  "property_price_range": "1524.5 - 2152.66",
  "property_price_min": "1524.5",
  "property_price_max": "2152.66",
  "property_available_units": 7,
  "property_facebook_url": "https://www.facebook.com/FairwaysatFeatherSound",
  "property_instagram_url": "https://www.instagram.com/fairwaysatfeathersound",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJe8b9JJXlwogR023FO0-ugH8",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/the-club-at-feather-sound-clearwater",
  "property_tiktok_url": "https://www.tiktok.com/@fairwaysatfeathersound",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Easy days, standout spaces.</strong> Start with a lakeside stroll, fit in a 24-hour fitness center workout, then unwind at the heated pool, hot tub, or oversized sundeck. Grilling areas, a clubroom with beverage bar, and an onsite dog park add more room to relax, while updated kitchens with quartz countertops, stainless-steel appliances, breakfast bars, and in-home washers/dryers bring everyday convenience home.</p>",
  "property_home_floorplans_blurb": "<p><strong>Find the layout that fits the day.</strong> Explore one- and two-bedroom apartments in Clearwater with practical space, stylish finishes, and options that add extra comfort. Select homes feature updated kitchens with quartz countertops, stainless-steel appliances, breakfast bars, in-home washer/dryer, wood-style flooring, generous storage, and extras like sunrooms, fireplaces, walk-in closets, or lake views.</p>",
  "property_home_gallery_blurb": "<p><strong>Preview the view from Fairways at Feather Sound.</strong> Browse bright interiors with quartz countertops, stainless-steel appliances, open living spaces, plush bedroom carpeting, and smart storage details—then step outside to lakeside scenes, a heated pool and hot tub, sundeck, fitness center, tennis court, grills, dog park, and walking paths framed by calm water views.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Tampa Bay connections, Feather Sound ease.</strong> From Fairways at Feather Sound, everyday stops at Echelon City Center, dinner at Bascom’s Chop House, and recreation near Feather Sound Country Club are all close by. I-275, Roosevelt Boulevard, and Ulmerton Road keep Clearwater, St. Petersburg, and Tampa within easy reach, while Sawgrass Lake Park and Weedon Island Preserve add boardwalks, mangroves, and fresh-air escapes to the map.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents call out the details that matter:</strong> responsive maintenance, friendly leasing support, clean grounds, and a calm Feather Sound setting. Reviews often mention quick service requests, easy parking, updated apartments, walking areas, pet-friendly touches, and well-kept amenities—with one resident describing their apartment as “a sanctuary.” Read more to see the experience in residents’ own words.</p>",
  "property_neighborhood_blurb": "<p><strong>Put Tampa Bay within easy reach.</strong> In Feather Sound, your day can move from coffee and errands at Echelon City Center to dinner at Bascom’s Chop House, a tee time or tennis near Feather Sound Country Club, and a quick connection onto I-275, Roosevelt Boulevard, or Ulmerton Road.</p><p>When you want green space, Sawgrass Lake Park’s boardwalks and observation tower are close by, with Weedon Island Preserve’s mangrove trails and paddling routes just beyond. Back at Fairways at Feather Sound, lakeside paths and comfortable <a href=\"/amenities\">community spaces</a> keep the neighborhood feel close to home. Explore the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Clearwater, St. Petersburg, and Tampa fit into your routine.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that make home feel refreshingly easy.</strong> At Fairways at Feather Sound, your routine can move from a lakeside walk to a workout in the 24-hour fitness center, then to the heated pool, hot tub, or large sundeck when it’s time to unwind. Meet up in the clubroom with beverage bar, enjoy the grills and picnic areas, or spend time outdoors with your pet at the onsite dog park.</p><p>Inside your Clearwater apartment, updated kitchens with quartz countertops, stainless-steel appliances, breakfast bars, and in-home washer/dryer convenience keep daily tasks simple, while select homes add fireplaces, walk-in closets, sunrooms, or lake views. Browse the <a href=\"/gallery\">amenity photos</a>, compare <a href=\"/floor-plans\">available layouts</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see the details in person.</p>",
  "property_applynow_blurb": "<p><strong>Start your application at Fairways at Feather Sound.</strong> Choose a comfortable one- or two-bedroom apartment in a lakeside Clearwater setting with walking trails, tropical landscaping, and resort-style ways to unwind. When you’re ready to make your move, apply online and take the next step toward calling Fairways home.</p>",
  "property_contactus_blurb": "<p><strong>Have questions about Fairways at Feather Sound?</strong> Our leasing team is here to help with one- and two-bedroom availability, community details, tour options, and directions to our lakeside Clearwater setting just off I-275. Reach out today and let us know how we can help.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Fairways at Feather Sound?</strong> Start here for helpful answers about the community, leasing, amenities, and everyday life in this lakeside Clearwater setting. If you don’t see what you need, the leasing team is happy to help you take the next step.</p>",
  "property_floorplans_blurb": "<p><strong>Compare the space, then picture the day.</strong> Fairways at Feather Sound offers one- and two-bedroom apartments in Clearwater with layouts that make the details easy to weigh: an efficient one-bedroom, a roomier one-bedroom, or a two-bedroom with the extra bath and separation you want.</p><p>As you browse available floor plans, look for the everyday upgrades that shape how each home lives—<a href=\"/amenities\">updated kitchens</a> with quartz countertops, tile backsplashes, stainless-steel appliances, breakfast bars, in-home washer/dryer, wood-style flooring, plush bedroom carpeting, generous storage, and select features like sunrooms, fireplaces, walk-in closets, or lake views. See a layout that feels right? <a href=\"/schedule-a-tour\">Schedule a tour</a> and take a closer look.</p>",
  "property_gallery_blurb": "<p><strong>See the setting before you step inside.</strong> In the Fairways at Feather Sound photo gallery, bright apartment scenes and lakeside views come together: quartz countertops, stainless-steel appliances, open living areas, plush bedroom carpeting, and storage details that help each space feel polished.</p><p>Swipe from the heated pool and hot tub to the lakeside sundeck, clubroom beverage bar, fitness center, tennis court, grills, and dog park, with walking paths and water views adding a calm Feather Sound backdrop. When a photo catches your eye, explore the <a href=\"/virtual-tours\">virtual tours</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the spaces in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Fairways at Feather Sound on the map.</strong><br>See available one- and two-bedroom apartments in a lakeside setting just off I-275, then zoom out to discover nearby dining, shopping, golf, airport access, and easy Tampa Bay connections.</p>",
  "property_pets_blurb": "<p><strong>Pet-friendly living with room to roam.</strong> At Fairways at Feather Sound, your cat can claim the sunny window and your dog can look forward to a daily routine that goes beyond the front door. Head to the <a href=\"/amenities\">onsite dog park</a> for off-leash play, follow the walking trails for a breezy loop by the community lakes, or relax at home with no weight limit for approved pets. With cats and dogs welcome, up to two per apartment home, it’s easy to plan around the companions already in your life. Nearby Feather Sound pet services make grooming, treats, and everyday supplies simple, while the leasing team can answer breed-restriction questions before you apply. <a href=\"/schedule-a-tour\">Schedule a tour</a> to see the pet-friendly spaces in person.</p>",
  "property_referafriend_blurb": "<p><strong>Share lakeside Clearwater living.</strong> Love the trails, tropical landscaping, heated pool, hot tub, fitness center, and comfortable one- or two-bedroom apartments? Invite a friend to experience Fairways at Feather Sound—and help them find their own place to feel at home here.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Fairways at Feather Sound.</strong><br>Carefree Clearwater living is easier to manage here. Log in to pay rent, submit maintenance requests, and keep your account up to date—so you can get back to enjoying the lakeside setting, walking trails, and resort-style comforts at home.</p>",
  "property_reviews_blurb": "<p><strong>Hear what residents notice most.</strong> As you read Fairways at Feather Sound reviews, you’ll see recurring praise for responsive maintenance, friendly leasing support, clean grounds, and a calm Feather Sound setting. Residents often mention quick service requests, helpful communication during move-in, and the everyday comfort of updated apartments, walking areas, and well-kept <a href=\"/amenities\">community amenities</a>. One review calls the apartment “a sanctuary,” while others highlight the quiet atmosphere, pet-friendly touches, easy parking, and a location that keeps daily errands and Tampa Bay connections within reach. Explore the full feedback below to see how residents describe the experience in their own words—then <a href=\"/schedule-a-tour\">schedule a tour</a> when you’re ready to see it for yourself.</p>",
  "property_created_at": "1752256371297",
  "property_scheduletour_blurb": "<p><strong>See lakeside Clearwater living up close.</strong><br>Tour Fairways at Feather Sound and picture your day among two community lakes, walking trails, tropical landscaping, and resort-style spaces made for relaxing, recharging, and unwinding. Schedule your visit today and find the one- or two-bedroom layout that feels right in person.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we’ve received your inquiry.</strong><br>Our leasing team will follow up soon to help with your next step. In the meantime, picture carefree Clearwater living in a lakeside Feather Sound setting, with comfortable one- and two-bedroom homes, tropical landscaping, walking trails, and resort-style spaces designed for easy everyday living.</p>",
  "property_virtualtours_blurb": "<p><strong>Step inside before you stop by.</strong> Explore Fairways at Feather Sound through immersive virtual tours that let you move at your own pace, pause on the details, and get a clearer feel for the spaces that shape daily life in Clearwater.</p><p>Start with the community tour to see the lakeside setting and outdoor atmosphere, then look inside the leasing office and clubhouse, fitness center, and business center. The available one-bedroom apartment tour gives you a closer view of the home itself, from the kitchen and living flow to storage, finishes, and the overall sense of space. When you are ready to compare layouts or see more in person, browse <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> with the leasing team.</p>",
  "property_copyright": "2025 All Rights Reserved. Fairways At Feather Sound",
  "property_seo_title_home": "Fairways At Feather Sound | Apartments in Clearwater, FL",
  "property_seo_description_home": "Elevate your lifestyle at Fairways At Feather Sound in Clearwater, FL, where modern living meets serene lake views. Choose from spacious one and two-bedroom floor plans and indulge in a wealth of premium amenities—from a sparkling heated pool and fitness center to a dog park and tennis court. Enjoy community perks like a clubhouse and scenic walking trails, all designed for ultimate comfort and convenience. Your ideal living space awaits—find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 2 Apartments in Clearwater, FL",
  "property_seo_description_floorplans": "Uncover the charm of Fairways At Feather Sound in beautiful Clearwater, FL. Our thoughtfully designed one and two-bedroom floor plans cater to every lifestyle, offering spacious living and modern amenities. Ready to find your ideal home? Browse our available apartments and start envisioning your new life today!",
  "property_seo_title_amenities": "Amenities | Clearwater, FL Apartments for Rent",
  "property_seo_description_amenities": "Unwind in the serene embrace of Fairways At Feather Sound in Clearwater, FL! Our community combines luxurious living with nature’s beauty, offering spacious one and two-bedroom floor plans with stunning lake views. Enjoy resort-style amenities, including a heated pool, dog park, and a quaint walking trail. With online resident services, a vibrant clubhouse, and a well-equipped fitness center, you’ll find everything you need right at your doorstep. Dive into a lifestyle of comfort and convenience—your perfect home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Clearwater, FL",
  "property_seo_description_gallery": "\"Picture yourself living in the serene beauty of Fairways At Feather Sound in Clearwater, FL. Our captivating Photo Gallery showcases the stunning lake views, modern floor plans, and an array of exceptional amenities, including a heated pool, dog park, and a vibrant clubhouse. With custom master closet organizers and relaxing walking trails, your dream home awaits. Dive into your future today!\"",
  "property_seo_title_virtualtours": "Virtual Tours | Fairways At Feather Sound Apartments",
  "property_seo_description_virtualtours": "\"Step into your future home at Fairways At Feather Sound in Clearwater, FL! Immerse yourself in our thoughtfully designed one and two-bedroom apartments where comfort meets style. Ready to envision your new lifestyle? Take a virtual tour of our vibrant community and see why Fairways At Feather Sound is the perfect place to call home!\"",
  "property_seo_title_interactivemap": "Interactive Map | Fairways At Feather Sound Apartments",
  "property_seo_description_interactivemap": "Uncover your perfect home at Fairways At Feather Sound in sunny Clearwater, FL. With a range of stylish one and two-bedroom floor plans, indulge in resort-style amenities including a heated pool, dog park, and serene walking trails. Our interactive community map simplifies your search for your dream apartment, showcasing pricing and available options, all with stunning lake views and modern comforts. Start envisioning your new lifestyle today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Clearwater, FL",
  "property_seo_description_neighborhood": "Uncover the vibrant lifestyle awaiting you at Fairways At Feather Sound in Clearwater, FL! With a selection of spacious one and two-bedroom floor plans, our community provides easy access to local hotspots and cherished gems. Dive into the neighborhood's unique offerings, from serene parks to dining delights, and find your perfect place in this thriving area. See what's around our community and experience the charm of Clearwater!",
  "property_seo_title_contact": "Contact Us | Fairways At Feather Sound",
  "property_seo_description_contact": "Find your perfect home at Fairways At Feather Sound in Clearwater, FL. With stylish one and two-bedroom apartments designed for comfort, our community offers the ideal backdrop for your lifestyle. Have questions? Reach out to our leasing team today and start your journey to elevated living!",
  "property_seo_title_faqs": "FAQs | Apartments in Clearwater, FL",
  "property_seo_description_faqs": "Uncover the answers you seek about Fairways At Feather Sound in Clearwater, FL! From our stunning one and two-bedroom options to an array of top-notch amenities like a heated pool, dog park, and scenic lake views, we ensure exceptional living experiences. Whether you're eager to dive into the fitness center or unwind by the community’s barbecue grill, our FAQs page offers insights to enhance your apartment journey. Get the information you need now!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Clearwater, FL",
  "property_seo_description_reviews": "Experience the exceptional lifestyle at Fairways At Feather Sound in Clearwater, FL. Our vibrant community offers an impressive selection of one and two-bedroom floor plans, complemented by amenities like a heated pool, dog park, and lush walking trails. With stunning lake views and a clubhouse perfect for social gatherings, your perfect oasis awaits. Don’t just take our word for it—see what our residents say about their home sweet home! ",
  "property_seo_title_applynow": "Apply Now | Apartments in Clearwater, FL",
  "property_seo_description_applynow": "Find your perfect sanctuary at Fairways At Feather Sound in Clearwater, FL, where modern living meets serene landscapes. Choose from spacious one and two-bedroom apartments, each tailored for comfort and style. Enjoy a wealth of amenities like a heated pool, tennis court, and scenic walking trails, all while soaking in stunning lake views. With online resident services and a vibrant clubhouse, your new home awaits. Lease online today and step into a lifestyle of convenience and leisure!",
  "property_seo_title_residentaccess": "Resident Access | Fairways At Feather Sound",
  "property_seo_description_residentaccess": "\"Welcome to Fairways At Feather Sound, your online gateway to convenient living in Clearwater, FL. Log in to your resident portal for easy rent payments, quick maintenance requests, and a streamlined community experience—your home, your way!\"",
  "property_seo_title_referafriend": "Refer A Friend | Fairways At Feather Sound",
  "property_seo_description_referafriend": "\"Transform your living experience at Fairways At Feather Sound in sunny Clearwater, FL! Share the joy of our vibrant community with friends and enjoy the perks together. Great friends make great neighbors—refer a friend today and unlock exclusive rewards!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Fairways At Feather Sound",
  "property_seo_description_scheduletour": "\"Step into a lifestyle of comfort and tranquility at Fairways At Feather Sound in Clearwater, FL. Schedule a tour today to experience our beautifully designed apartments, lush landscapes, and welcoming community. Your new home awaits!\"",
  "property_seo_title_privacy": "Privacy Policy | Fairways At Feather Sound",
  "property_seo_description_privacy": "\"At Fairways At Feather Sound in Clearwater, FL, your comfort and security are our top priorities. Dive into our Privacy Policy to discover how we safeguard your information while you enjoy a tranquil lifestyle in our vibrant community. View our commitment to your privacy today!\"",
  "property_seo_title_accessibility": "Website Accessibility | Fairways At Feather Sound",
  "property_seo_description_accessibility": "\"At Fairways At Feather Sound in Clearwater, FL, we prioritize accessibility and digital inclusion for all. Navigate our commitment to a welcoming community where everyone can thrive. Your comfort and convenience matter to us—join us in fostering an inclusive environment.\"",
  "property_seo_title_sitemap": "Sitemap | Fairways At Feather Sound",
  "property_seo_description_sitemap": "\"Navigate your dream living space at Fairways At Feather Sound in Clearwater, FL. Our sitemap makes finding your perfect apartment easy and exciting. Dive in to explore layouts, amenities, and the vibrant lifestyle awaiting you!\"",
  "property_seo_title_thankyou": "Thank You | Fairways At Feather Sound",
  "property_seo_description_thankyou": "Thank you for reaching out to Fairways At Feather Sound! Your interest in our vibrant Clearwater community is appreciated. Rest assured, our team is eager to assist you in finding your perfect home. Stay tuned for a prompt response – your new lifestyle awaits!",
  "property_seo_title_pets": "Pet Policy | Apartments in Austell, GA\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234319882",
  "amenities": [
    {
      "id": "custom_33c03f93-da13-4b12-8f17-5abf0c03b70e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bbe78533-62b5-43c2-b20b-cc20c5c326fb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "custom",
      "external_id": "P000000607",
      "title": "Business Center",
      "amount": "0.0000",
      "description": "Business Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4db875fd-bb2c-4dd7-bc54-31472a83a726",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "custom",
      "external_id": "P000000614",
      "title": "Clubhouse",
      "amount": "0.0000",
      "description": "Clubroom w/Beverage Bar",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cb29899a-58a2-4e51-b26f-0819321f468c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "custom",
      "external_id": "P000000626",
      "title": "Dog Park",
      "amount": "0.0000",
      "description": "Onsite Dog Park",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3e89a976-f530-43e0-b832-f9414dfea9dc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "24-Hour Fitness Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_be9b1635-fe5b-418f-8113-28b258274da6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "custom",
      "external_id": "P000000647",
      "title": "Heated Pool",
      "amount": "0.0000",
      "description": "Heated Swimming Pool",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9361eaf1-ca50-4c0d-9196-f4628b18f7ad",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "custom",
      "external_id": "P000000653",
      "title": "Lake",
      "amount": "0.0000",
      "description": "2 Private Community Lakes",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cc45b7e2-be22-4b40-910e-ae89c781e775",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a32605e3-7cbf-4612-93f4-da665c66bfcf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "custom",
      "external_id": "P000000688",
      "title": "Sundeck",
      "amount": "0.0000",
      "description": "Large Lakeside Sundeck",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cf6abf8b-6a7c-4210-a8f7-c3423e77281a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "custom",
      "external_id": "P000000692",
      "title": "Tennis Court",
      "amount": "0.0000",
      "description": "Lighted Tennis Court",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ce8cbfab-65ed-4a8a-8a81-e69d212cebb8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "custom",
      "external_id": "P000000697",
      "title": "Tubs",
      "amount": "0.0000",
      "description": "Hot Tub",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1d3444a9-9fde-4ac5-b10a-88f85eacbb0c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "custom",
      "external_id": "P000000706",
      "title": "Walking Trail",
      "amount": "0.0000",
      "description": "Walking Trails",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_eeef4938-c44c-4926-98a8-8bf29b394161",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "custom",
      "external_id": "P000001338",
      "title": "Barbeque/Grill",
      "amount": "0.0000",
      "description": "Community Grills & Picnic Area",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_fd1108c4-91cf-4fcb-9cfc-b3ed7601761c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019e8997-7e35-710b-be9d-f6e89359c06a.webp",
      "image_media": {
        "alt_text": "Fitness center gym with treadmills, weight machines, and free weights.",
        "public_id": "019e8997-7e35-710b-be9d-f6e89359c06a",
        "storage_key": "property/5641831400341504/019e8997-7e35-710b-be9d-f6e89359c06a.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Stay active and healthy in our fully-equipped fitness center, featuring state-of-the-art cardio and strength training equipment for a complete workout.",
      "link": "",
      "alt_text": "Fitness center gym with treadmills, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b73efeda-c358-4484-8ba8-8d70d5c9ec1b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019e8997-750e-74ba-9745-6085751e8739.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a granite countertop, white vanity, and large mirror.",
        "public_id": "019e8997-750e-74ba-9745-6085751e8739",
        "storage_key": "property/5641831400341504/019e8997-750e-74ba-9745-6085751e8739.webp",
        "width": 3072,
        "height": 2054
      },
      "title": "Apartment",
      "description": "Spacious and modern bathroom featuring a granite countertop, ample storage in the white vanity, and a large mirror. Perfect for your daily routine.",
      "link": "",
      "alt_text": "Modern bathroom with a granite countertop, white vanity, and large mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0897155a-1414-4110-8284-d450c9a631d8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019e8997-7268-73e9-b4af-12ec27b41039.webp",
      "image_media": {
        "alt_text": "Wooden pier and gazebo overlooking a serene lake with apartment buildings in the background.",
        "public_id": "019e8997-7268-73e9-b4af-12ec27b41039",
        "storage_key": "property/5641831400341504/019e8997-7268-73e9-b4af-12ec27b41039.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the waterfront views from our scenic pier and gazebo, perfect for relaxing by the lake. This amenity enhances the community's outdoor living experience.",
      "link": "",
      "alt_text": "Wooden pier and gazebo overlooking a serene lake with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5acffb29-e60a-4da7-aacd-d6bc29fcec89",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019e8997-6077-71c9-a4f4-bf666fa728cc.webp",
      "image_media": {
        "alt_text": "Modern living room with gray sofa, abstract art, and dining area.",
        "public_id": "019e8997-6077-71c9-a4f4-bf666fa728cc",
        "storage_key": "property/5641831400341504/019e8997-6077-71c9-a4f4-bf666fa728cc.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and stylish living area featuring a comfortable gray sofa, decorative pillows, and contemporary artwork, adjacent to a dining space.",
      "link": "",
      "alt_text": "Modern living room with gray sofa, abstract art, and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bd86f76c-893c-4808-b5b5-668983896c58",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019e8997-632d-716e-939d-7d1a3631171a.webp",
      "image_media": {
        "alt_text": "Dining area with table and chairs, adjacent to a modern kitchen with stainless steel appliances.",
        "public_id": "019e8997-632d-716e-939d-7d1a3631171a",
        "storage_key": "property/5641831400341504/019e8997-632d-716e-939d-7d1a3631171a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy a spacious dining area adjacent to a modern kitchen, perfect for meals with friends and family. Featuring stainless steel appliances and ample counter space.",
      "link": "",
      "alt_text": "Dining area with table and chairs, adjacent to a modern kitchen with stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_248068b0-9325-4881-8a92-d3cee22b1882",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019e8997-5dd6-71ab-8db7-bc246fd2a039.webp",
      "image_media": {
        "alt_text": "Swimming pool and lounge chairs with a lake view.",
        "public_id": "019e8997-5dd6-71ab-8db7-bc246fd2a039",
        "storage_key": "property/5641831400341504/019e8997-5dd6-71ab-8db7-bc246fd2a039.webp",
        "width": 3072,
        "height": 2053
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, complete with comfortable lounge chairs and scenic lake views.",
      "link": "",
      "alt_text": "Swimming pool and lounge chairs with a lake view.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9585a987-8e45-4bf1-94f3-37a37e43b889",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019e8997-6ca6-7362-bb79-d56688140acf.webp",
      "image_media": {
        "alt_text": "Luxurious bedroom with a large bed, decorative pillows, and modern art.",
        "public_id": "019e8997-6ca6-7362-bb79-d56688140acf",
        "storage_key": "property/5641831400341504/019e8997-6ca6-7362-bb79-d56688140acf.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfort and style in our spacious bedrooms, featuring plush bedding and elegant decor for a truly relaxing retreat.",
      "link": "",
      "alt_text": "Luxurious bedroom with a large bed, decorative pillows, and modern art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e9c54017-ddb3-4ff0-992f-a372a9a232c4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019e8997-6577-7617-a82b-efab689c6755.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with picnic tables under a shaded canopy.",
        "public_id": "019e8997-6577-7617-a82b-efab689c6755",
        "storage_key": "property/5641831400341504/019e8997-6577-7617-a82b-efab689c6755.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy outdoor dining with our community grilling stations and picnic tables, perfect for gatherings.",
      "link": "",
      "alt_text": "Outdoor grilling area with picnic tables under a shaded canopy.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_14c6881d-6ab0-4147-b8dd-2fd4babc67a7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019e8997-66a5-74b6-b22a-1d8136f1feff.webp",
      "image_media": {
        "alt_text": "Business center with a printer and laptops on a counter with stools.",
        "public_id": "019e8997-66a5-74b6-b22a-1d8136f1feff",
        "storage_key": "property/5641831400341504/019e8997-66a5-74b6-b22a-1d8136f1feff.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Utilize our modern business center, complete with a printer and laptops, to stay connected and productive.",
      "link": "",
      "alt_text": "Business center with a printer and laptops on a counter with stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c241fb8c-0019-4dcd-850f-b205e3c191bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019e8997-5fba-750f-a52e-4ef96ceed01e.webp",
      "image_media": {
        "alt_text": "Treadmills, weight racks, and a squat rack in a modern fitness center.",
        "public_id": "019e8997-5fba-750f-a52e-4ef96ceed01e",
        "storage_key": "property/5641831400341504/019e8997-5fba-750f-a52e-4ef96ceed01e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center features treadmills, free weights, and strength training equipment to help you stay active and healthy.",
      "link": "",
      "alt_text": "Treadmills, weight racks, and a squat rack in a modern fitness center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_43518603-5309-426b-bfb8-87085de849aa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019e8997-64e5-708a-9772-0f573f0efdc1.webp",
      "image_media": {
        "alt_text": "Cozy reading nook with a butterfly chair, desk, and large windows overlooking water.",
        "public_id": "019e8997-64e5-708a-9772-0f573f0efdc1",
        "storage_key": "property/5641831400341504/019e8997-64e5-708a-9772-0f573f0efdc1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Create your personal oasis in this inviting reading nook, complete with a comfortable butterfly chair, a stylish desk, and expansive windows offering serene water views.",
      "link": "",
      "alt_text": "Cozy reading nook with a butterfly chair, desk, and large windows overlooking water.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_63d3c918-8dea-4540-a1bb-31216f438d2e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019e8997-5c1c-721e-aaff-e1a375936fe5.webp",
      "image_media": {
        "alt_text": "Blue tennis court with green outer surface, net, and buildings in the background.",
        "public_id": "019e8997-5c1c-721e-aaff-e1a375936fe5",
        "storage_key": "property/5641831400341504/019e8997-5c1c-721e-aaff-e1a375936fe5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a friendly match on our vibrant blue tennis court, complete with a net and surrounded by lush landscaping and scenic water views.",
      "link": "",
      "alt_text": "Blue tennis court with green outer surface, net, and buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_270f678b-148f-4ac5-ac12-50e85f7604d1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019e8997-583b-7258-817a-7803a1031fbe.webp",
      "image_media": {
        "alt_text": "Lounge chairs and a circular daybed by a lake with a gazebo and apartment buildings in the background.",
        "public_id": "019e8997-583b-7258-817a-7803a1031fbe",
        "storage_key": "property/5641831400341504/019e8997-583b-7258-817a-7803a1031fbe.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our beautiful lake, complete with comfortable lounge seating and a charming gazebo.",
      "link": "",
      "alt_text": "Lounge chairs and a circular daybed by a lake with a gazebo and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_412cacf2-4ea0-48ea-b82a-47bebe6906a3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019e8997-56fd-76b9-9209-f7a2f1c7d389.webp",
      "image_media": {
        "alt_text": "Whirlpool washer and dryer in a laundry room with decorative wall hanging.",
        "public_id": "019e8997-56fd-76b9-9209-f7a2f1c7d389",
        "storage_key": "property/5641831400341504/019e8997-56fd-76b9-9209-f7a2f1c7d389.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Laundry room featuring a white Whirlpool washer and dryer set, complemented by a neutral-toned decorative wall hanging.",
      "link": "",
      "alt_text": "Whirlpool washer and dryer in a laundry room with decorative wall hanging.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f9aa119c-78c8-425a-a311-5f15b1628213",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019e8997-3e1e-753e-9dbc-042060588984.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment and seating",
        "public_id": "019e8997-3e1e-753e-9dbc-042060588984",
        "storage_key": "property/5641831400341504/019e8997-3e1e-753e-9dbc-042060588984.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our on-site dog park, complete with agility obstacles and a comfortable bench for you to relax on.",
      "link": "",
      "alt_text": "Dog park with agility equipment and seating",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_df121d26-713b-41ca-8b29-9d7cd5c36fa9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019e8997-3cf7-704d-af01-82b96b3b2a60.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with pathway leading to entrance, surrounded by trees and landscaping.",
        "public_id": "019e8997-3cf7-704d-af01-82b96b3b2a60",
        "storage_key": "property/5641831400341504/019e8997-3cf7-704d-af01-82b96b3b2a60.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "View of the apartment building exterior featuring a central pathway leading to the entrance. Lush greenery and palm trees surround the well-maintained property.",
      "link": "",
      "alt_text": "Exterior of apartment building with pathway leading to entrance, surrounded by trees and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ded6bf0e-efa3-4ddd-ac7c-3ae920f7e848",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019e8997-3da6-76fb-bfd6-3d75fb537394.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool and hot tub with lounge chairs and palm trees overlooking a lake.",
        "public_id": "019e8997-3da6-76fb-bfd6-3d75fb537394",
        "storage_key": "property/5641831400341504/019e8997-3da6-76fb-bfd6-3d75fb537394.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy the resort-style swimming pool and hot tub, surrounded by lounge chairs and tropical palm trees, with a beautiful lake view.",
      "link": "",
      "alt_text": "Resort-style swimming pool and hot tub with lounge chairs and palm trees overlooking a lake.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_97bfdcea-a9fd-4ae7-a8d2-b6b0a0904543",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019e8997-3fa0-74e0-9820-6bec3d342aa9.webp",
      "image_media": {
        "alt_text": "Secure package lockers with the Hub and Amazon logo.",
        "public_id": "019e8997-3fa0-74e0-9820-6bec3d342aa9",
        "storage_key": "property/5641831400341504/019e8997-3fa0-74e0-9820-6bec3d342aa9.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Modern and secure package lockers provide residents with convenient access to their deliveries.",
      "link": "",
      "alt_text": "Secure package lockers with the Hub and Amazon logo.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_90d8498d-4d77-4272-99ed-7cff2abb40fd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019e8997-4264-7748-8590-8e0a27e0fc82.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-sized bed, nightstands, dresser, and a ceiling fan.",
        "public_id": "019e8997-4264-7748-8590-8e0a27e0fc82",
        "storage_key": "property/5641831400341504/019e8997-4264-7748-8590-8e0a27e0fc82.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in this beautifully appointed bedroom featuring a plush king-sized bed, stylish nightstands, a modern dresser, and a refreshing ceiling fan.",
      "link": "",
      "alt_text": "Bedroom with a king-sized bed, nightstands, dresser, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_45ae67f7-2d28-495e-a7ed-c545a66fce98",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019e8997-43cd-73ce-bce8-7aeebf62b7df.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs, umbrellas, tables, chairs, and a built-in grill.",
        "public_id": "019e8997-43cd-73ce-bce8-7aeebf62b7df",
        "storage_key": "property/5641831400341504/019e8997-43cd-73ce-bce8-7aeebf62b7df.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind by the resort-style pool, featuring comfortable seating, shaded areas, and a barbecue grill perfect for outdoor gatherings.",
      "link": "",
      "alt_text": "Outdoor swimming pool area with lounge chairs, umbrellas, tables, chairs, and a built-in grill.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_071b5779-663b-4040-af8f-96ac233aebf7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019e8997-3c2d-746f-a6c4-d0994c69e723.webp",
      "image_media": {
        "alt_text": "Apartment buildings along a serene lake with a fountain.",
        "public_id": "019e8997-3c2d-746f-a6c4-d0994c69e723",
        "storage_key": "property/5641831400341504/019e8997-3c2d-746f-a6c4-d0994c69e723.webp",
        "width": 3072,
        "height": 2052
      },
      "title": "Community",
      "description": "Enjoy the tranquil ambiance of our community, featuring a beautiful lake with a calming fountain and lush green spaces.",
      "link": "",
      "alt_text": "Apartment buildings along a serene lake with a fountain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8b9616d1-eca5-4640-a28b-b3307735a9c9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019e8997-3ce3-77ad-b5cc-0d5906d74f7e.webp",
      "image_media": {
        "alt_text": "Communal lounge area with kitchen counter and seating overlooking outdoor amenities.",
        "public_id": "019e8997-3ce3-77ad-b5cc-0d5906d74f7e",
        "storage_key": "property/5641831400341504/019e8997-3ce3-77ad-b5cc-0d5906d74f7e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish communal lounge, featuring a modern kitchen island and comfortable seating with scenic views of the community's outdoor spaces.",
      "link": "",
      "alt_text": "Communal lounge area with kitchen counter and seating overlooking outdoor amenities.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b85ff601-0e46-4605-996f-d2eb41598dbd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019e8997-3bb5-74af-8430-2b1fc4ce2a55.webp",
      "image_media": {
        "alt_text": "Modern living room with a grey sofa, coffee table, large rug, and TV.",
        "public_id": "019e8997-3bb5-74af-8430-2b1fc4ce2a55",
        "storage_key": "property/5641831400341504/019e8997-3bb5-74af-8430-2b1fc4ce2a55.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this spacious apartment featuring a stylish living room with ample seating and entertainment space.",
      "link": "",
      "alt_text": "Modern living room with a grey sofa, coffee table, large rug, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5758a2f2-9e78-4018-bb37-6df2c780630e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019e8997-3cde-745e-abe6-ecef6cae989e.webp",
      "image_media": {
        "alt_text": "View into a bedroom from a closet with shelves and hangers.",
        "public_id": "019e8997-3cde-745e-abe6-ecef6cae989e",
        "storage_key": "property/5641831400341504/019e8997-3cde-745e-abe6-ecef6cae989e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into comfort with this spacious bedroom, featuring a convenient walk-in closet.",
      "link": "",
      "alt_text": "View into a bedroom from a closet with shelves and hangers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_179330ca-6eb0-4ecc-b6f4-a2e3b67854df",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019e8997-2843-7366-909b-04f45244a7ff.webp",
      "image_media": {
        "alt_text": "Modern galley kitchen with stainless steel appliances, white cabinets, and granite countertops.",
        "public_id": "019e8997-2843-7366-909b-04f45244a7ff",
        "storage_key": "property/5641831400341504/019e8997-2843-7366-909b-04f45244a7ff.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this updated galley kitchen, featuring sleek stainless steel appliances, elegant granite countertops, and ample white cabinetry for all your storage needs.",
      "link": "",
      "alt_text": "Modern galley kitchen with stainless steel appliances, white cabinets, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_52dadffc-a0e0-41b8-9e7c-d6e623727898",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019e8997-2588-7156-81b5-abc98599aaf4.webp",
      "image_media": {
        "alt_text": "Living room with gray couch, coffee table, and patterned rug.",
        "public_id": "019e8997-2588-7156-81b5-abc98599aaf4",
        "storage_key": "property/5641831400341504/019e8997-2588-7156-81b5-abc98599aaf4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish and modern living room featuring a comfortable gray sofa, a chic coffee table with decorative items, and a striking geometric rug.",
      "link": "",
      "alt_text": "Living room with gray couch, coffee table, and patterned rug.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_a5495ec8c6307344bbd1d3d2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Mangroves Café",
      "poi_type": "Restaurants",
      "poi_address": "13577 Feather Sound Dr Ste 180, Clearwater, FL 33762, USA",
      "poi_short_description": "Relaxed eatery with a friendly staff dishing up Cuban fare, sandwiches and smoothies.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1508-aa6a-74d3-9f7f-a8da4ff1d886.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-aa6a-74d3-9f7f-a8da4ff1d886",
        "storage_key": "property/5641831400341504/019f1508-aa6a-74d3-9f7f-a8da4ff1d886.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.mangrovescafe.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16270677818400151600&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mangroves-caf",
      "poi_latitude": "27.8956348",
      "poi_longitude": "-82.6608397",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 727-827-7917",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad07-75fd-ab81-da780ab3f1b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad07-75fd-ab81-da780ab3f1b6",
        "storage_key": "property/5641831400341504/019f1505-ad07-75fd-ab81-da780ab3f1b6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJaVcBWOjlwogRMJiRJEUPzeE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_595580781701acd14342b000",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Clearwater Bagels",
      "poi_type": "Restaurants",
      "poi_address": "1871 Gulf To Bay Blvd, Clearwater, FL 33765, USA",
      "poi_short_description": "New York-style bagels, cream cheeses and spreads are sold at this no-frills storefront.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1508-a5bc-774d-9db7-ebeb910842d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-a5bc-774d-9db7-ebeb910842d7",
        "storage_key": "property/5641831400341504/019f1508-a5bc-774d-9db7-ebeb910842d7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/Clearwater-Bagels-506410672730397/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10938406925934995073&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clearwater-bagels",
      "poi_latitude": "27.9603396",
      "poi_longitude": "-82.7598707",
      "poi_miles_from_property": "9.6 mi",
      "poi_walking_minutes": "3 hours 34 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 727-446-7631",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad07-75fd-ab81-da780ab3f1b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad07-75fd-ab81-da780ab3f1b6",
        "storage_key": "property/5641831400341504/019f1505-ad07-75fd-ab81-da780ab3f1b6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWzCeHEnwwogRgSYHHSUHzZc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bagel_shop"
    },
    {
      "id": "ec_182f9692e893484c31410001",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Panera Bread",
      "poi_type": "Restaurants",
      "poi_address": "2285 Ulmerton Rd, Clearwater, FL 33762, USA",
      "poi_short_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_long_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1508-abfb-7711-84b1-57c743705eae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-abfb-7711-84b1-57c743705eae",
        "storage_key": "property/5641831400341504/019f1508-abfb-7711-84b1-57c743705eae.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.panerabread.com/en-us/cafe/locations/fl/clearwater/2285-ulmerton-road?utm_medium=local&utm_source=google&utm_campaign=dpm-dist&utm_term=203341&utm_content=main",
      "poi_directions_map_url": "https://maps.google.com/?cid=9930602238905074866&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "panera-bread",
      "poi_latitude": "27.894467",
      "poi_longitude": "-82.664842",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 727-592-9690",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-896c-75f1-b25e-ad082fc3a6f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1509-896c-75f1-b25e-ad082fc3a6f9",
        "storage_key": "property/5641831400341504/019f1509-896c-75f1-b25e-ad082fc3a6f9.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJz50NA-rlwogRssSiJx-W0Ik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "ec_3daa6b8f7370fb0964f77c1f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "3423 Ulmerton Rd, Clearwater, FL 33762, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1508-a4ff-7182-99d0-5d5c3c6dbb94.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-a4ff-7182-99d0-5d5c3c6dbb94",
        "storage_key": "property/5641831400341504/019f1508-a4ff-7182-99d0-5d5c3c6dbb94.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/fl/feathersound?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=6079773754907357352&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "27.8943788",
      "poi_longitude": "-82.6806187",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 727-572-7775",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad07-75fd-ab81-da780ab3f1b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad07-75fd-ab81-da780ab3f1b6",
        "storage_key": "property/5641831400341504/019f1505-ad07-75fd-ab81-da780ab3f1b6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2S9YB5jlwogRqPD-nwSyX1Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "ec_457a5665b25923d3b8249d5c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Sacred Spice Indian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "2325 Ulmerton Rd Ste 28, Clearwater, FL 33762, USA",
      "poi_short_description": "Relaxed dining space with a bar area, serving traditional Indian dishes such as tandoori and biriyani.",
      "poi_long_description": "Relaxed dining space with a bar area, serving traditional Indian dishes such as tandoori and biriyani.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1508-9f87-73de-a05a-1c6ab35d9e3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-9f87-73de-a05a-1c6ab35d9e3a",
        "storage_key": "property/5641831400341504/019f1508-9f87-73de-a05a-1c6ab35d9e3a.webp",
        "width": 1280,
        "height": 1128
      },
      "poi_business_url": "https://thesacredspice.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14138269131221848092&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sacred-spice-indian-restaurant",
      "poi_latitude": "27.8943699",
      "poi_longitude": "-82.6665926",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 727-202-7713",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad07-75fd-ab81-da780ab3f1b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad07-75fd-ab81-da780ab3f1b6",
        "storage_key": "property/5641831400341504/019f1505-ad07-75fd-ab81-da780ab3f1b6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFzk8Y-rlwogRHFBZ-d04NcQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indian_restaurant"
    },
    {
      "id": "ec_349e5ac5e14f6875337adf21",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Grand Hacienda",
      "poi_type": "Restaurants",
      "poi_address": "2325 Ulmerton Rd #3, Clearwater, FL 33762, USA",
      "poi_short_description": "Casual, cozy restaurant and bar for tacos, enchiladas, fajitas and other Mexico City staples.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1508-a677-75fc-9576-0a063a510c6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-a677-75fc-9576-0a063a510c6d",
        "storage_key": "property/5641831400341504/019f1508-a677-75fc-9576-0a063a510c6d.webp",
        "width": 1256,
        "height": 716
      },
      "poi_business_url": "https://grandhaciendarestaurant.com/ulmerton/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13773594068562219586&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grand-hacienda",
      "poi_latitude": "27.8947367",
      "poi_longitude": "-82.6672425",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 727-623-9140",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad07-75fd-ab81-da780ab3f1b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad07-75fd-ab81-da780ab3f1b6",
        "storage_key": "property/5641831400341504/019f1505-ad07-75fd-ab81-da780ab3f1b6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ69iBTvlwogRQhIUadSiJb8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_e57b78f23bc36714802666f3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Bascom's Chop House",
      "poi_type": "Restaurants",
      "poi_address": "3665 Ulmerton Rd, Clearwater, FL 33762, USA",
      "poi_short_description": "Luxe pick for aged Angus beef with a choice of sauces & toppings, plus seafood & a vast wine list.",
      "poi_long_description": "Luxe pick for aged Angus beef with a choice of sauces & toppings, plus seafood & a vast wine list.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1508-a8f3-76f8-a31c-8df8735fa62e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-a8f3-76f8-a31c-8df8735fa62e",
        "storage_key": "property/5641831400341504/019f1508-a8f3-76f8-a31c-8df8735fa62e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://bascoms.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=73882693463180815&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bascoms-chop-house",
      "poi_latitude": "27.8946067",
      "poi_longitude": "-82.68382489999999",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 727-573-3363",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad07-75fd-ab81-da780ab3f1b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad07-75fd-ab81-da780ab3f1b6",
        "storage_key": "property/5641831400341504/019f1505-ad07-75fd-ab81-da780ab3f1b6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1wNIe6LlwogRDwbsEut7BgE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "ec_43ab00319337ad5e87135b96",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Courtside Grille",
      "poi_type": "Restaurants",
      "poi_address": "110 Fountain Pkwy N, St. Petersburg, FL 33716, USA",
      "poi_short_description": "Large pub serving American eats, sushi & cocktails in modern digs with sports memorabilia & a patio.",
      "poi_long_description": "Large pub serving American eats, sushi & cocktails in modern digs with sports memorabilia & a patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1508-a559-72cb-9f3c-0238d5422c30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-a559-72cb-9f3c-0238d5422c30",
        "storage_key": "property/5641831400341504/019f1508-a559-72cb-9f3c-0238d5422c30.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://courtsidegrillestpete.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1872374184404045849&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "courtside-grille",
      "poi_latitude": "27.893164",
      "poi_longitude": "-82.66025789999999",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 727-561-7433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad3a-70d6-a324-a83777dc2598.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad3a-70d6-a324-a83777dc2598",
        "storage_key": "property/5641831400341504/019f1505-ad3a-70d6-a324-a83777dc2598.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8zXCo8LlwogRGdADhGYC_Bk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "ec_6bd81cf03398494c4ae7c458",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Aviators Tavern",
      "poi_type": "Restaurants",
      "poi_address": "3535 Ulmerton Rd, Clearwater, FL 33762, USA",
      "poi_short_description": "Low-key tavern at the Holiday Inn offering classic pub eats, sports on TV & a full bar.",
      "poi_long_description": "Low-key tavern at the Holiday Inn offering classic pub eats, sports on TV & a full bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1508-ab9a-76e7-a64c-d3588f6b8405.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-ab9a-76e7-a64c-d3588f6b8405",
        "storage_key": "property/5641831400341504/019f1508-ab9a-76e7-a64c-d3588f6b8405.webp",
        "width": 1280,
        "height": 843
      },
      "poi_business_url": "http://www.aviatorstavern.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14660340642366125511&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aviators-tavern",
      "poi_latitude": "27.8948165",
      "poi_longitude": "-82.6823658",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 727-577-9100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad07-75fd-ab81-da780ab3f1b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad07-75fd-ab81-da780ab3f1b6",
        "storage_key": "property/5641831400341504/019f1505-ad07-75fd-ab81-da780ab3f1b6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQdjJdZjlwogRx3V08iP-c8s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_ddd7ef9fcb58aface4902605",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Luna Lux Restaurant & Lounge",
      "poi_type": "Restaurants",
      "poi_address": "950 Lake Carillon Dr, St. Petersburg, FL 33716, USA",
      "poi_short_description": "Slick eatery & lounge in the Hilton Hotel with upscale American fare for breakfast, lunch & dinner.",
      "poi_long_description": "Slick eatery & lounge in the Hilton Hotel with upscale American fare for breakfast, lunch & dinner.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1508-a439-7229-8d17-1c8d635dcec5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-a439-7229-8d17-1c8d635dcec5",
        "storage_key": "property/5641831400341504/019f1508-a439-7229-8d17-1c8d635dcec5.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.lunastpete.com/?utm_source=google&utm_medium=organic&utm_campaign=gbp_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=13155763778197806619&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "luna-lux-restaurant--lounge",
      "poi_latitude": "27.8905825",
      "poi_longitude": "-82.665674",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 727-954-2140",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad07-75fd-ab81-da780ab3f1b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad07-75fd-ab81-da780ab3f1b6",
        "storage_key": "property/5641831400341504/019f1505-ad07-75fd-ab81-da780ab3f1b6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJk3R-AsHlwogRG15uPHSpkrY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_704f9350054e3f333e934955",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "SeaGuini - Opal Sands Resort",
      "poi_type": "Restaurants",
      "poi_address": "430 S Gulfview Blvd, Clearwater Beach, FL 33767, USA",
      "poi_short_description": "Chic restaurant & lounge at Opal Sands resort with seafood, Italian-inspired cuisine & water views.",
      "poi_long_description": "Chic restaurant & lounge at Opal Sands resort with seafood, Italian-inspired cuisine & water views.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1508-b443-703f-821e-4c25f8c1e70c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-b443-703f-821e-4c25f8c1e70c",
        "storage_key": "property/5641831400341504/019f1508-b443-703f-821e-4c25f8c1e70c.webp",
        "width": 1280,
        "height": 730
      },
      "poi_business_url": "https://www.opalcollection.com/opal-sands/restaurants/seaguini/?utm_source=google&utm_medium=listing&utm_campaign=opal+sands+resort+seaguini",
      "poi_directions_map_url": "https://maps.google.com/?cid=5994335266957360250&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seaguini---opal-sands-resort",
      "poi_latitude": "27.9696407",
      "poi_longitude": "-82.8302154",
      "poi_miles_from_property": "14.8 mi",
      "poi_walking_minutes": "5 hours 30 mins",
      "poi_biking_minutes": "1 hour 22 mins",
      "poi_driving_minutes": "32 mins",
      "poi_business_phone": "+1 727-450-6236",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad07-75fd-ab81-da780ab3f1b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad07-75fd-ab81-da780ab3f1b6",
        "storage_key": "property/5641831400341504/019f1505-ad07-75fd-ab81-da780ab3f1b6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgd7cXij3wogRevyWeyooMFM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "ec_472a91a1597b9db314370e4d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Hogg Daddy's Beach Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "752 S Gulfview Blvd, Clearwater Beach, FL 33767, USA",
      "poi_short_description": "Casual beachside sports bar and BBQ eatery with a fun vibe serving oysters and other seafood.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1508-b314-71fc-a300-fe3ed133c6d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-b314-71fc-a300-fe3ed133c6d6",
        "storage_key": "property/5641831400341504/019f1508-b314-71fc-a300-fe3ed133c6d6.webp",
        "width": 926,
        "height": 619
      },
      "poi_business_url": "http://www.hoggdaddys.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6985559854829887251&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hogg-daddys-beach-bar--grill",
      "poi_latitude": "27.9664625",
      "poi_longitude": "-82.8229447",
      "poi_miles_from_property": "15.3 mi",
      "poi_walking_minutes": "5 hours 42 mins",
      "poi_biking_minutes": "1 hour 25 mins",
      "poi_driving_minutes": "33 mins",
      "poi_business_phone": "+1 727-953-3040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad07-75fd-ab81-da780ab3f1b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad07-75fd-ab81-da780ab3f1b6",
        "storage_key": "property/5641831400341504/019f1505-ad07-75fd-ab81-da780ab3f1b6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJA7fK-DH3wogRE19dSK2x8WA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_4b107467d94cdf810ce69ee8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Gigglewaters",
      "poi_type": "Restaurants",
      "poi_address": "737 Main St #104, Safety Harbor, FL 34695, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1508-b314-71fc-a300-f8f5f61f88db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-b314-71fc-a300-f8f5f61f88db",
        "storage_key": "property/5641831400341504/019f1508-b314-71fc-a300-f8f5f61f88db.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "http://gigglewaters.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15534172514351184350&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gigglewaters",
      "poi_latitude": "27.9910808",
      "poi_longitude": "-82.69476159999999",
      "poi_miles_from_property": "11.9 mi",
      "poi_walking_minutes": "4 hours 26 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 727-669-7077",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad07-75fd-ab81-da780ab3f1b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad07-75fd-ab81-da780ab3f1b6",
        "storage_key": "property/5641831400341504/019f1505-ad07-75fd-ab81-da780ab3f1b6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJEV6gLQXvwogR3vmJJZl3lNc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_0b864776b43a521a87fb5303",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Ken Sushi & Asian Bistro",
      "poi_type": "Restaurants",
      "poi_address": "2801 Gulf To Bay Blvd, Clearwater, FL 33759, USA",
      "poi_short_description": "Traditional Japanese dishes, an extensive sushi menu, & sit-down sushi bar with pagoda-style awning.",
      "poi_long_description": "Traditional Japanese dishes, an extensive sushi menu, & sit-down sushi bar with pagoda-style awning.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJDw_mfM7vwogRuBYpZ0740Po/photos/AaVGc3lur-oLsn3GfvDdlyoO_m-ZiANtXxwgmgP8GF3_mdDSqtOFWknBrfN8t6OL1CqzKnywSESToR2puMfzstUIzdrZzNi7mkAzmADyFQBARWoWqyPLpIQ0Bq7qgWXXIoABKseQwtixDUYnm597qB0BltGdHsVJ5b5oESWMPe0gLpxi6Wf9fw4cGfuYtEdi3V1eopQhA00kHSEWlkwgGZgjqBeWFC_mrp1B-gmA8Tt5pn8MTikaQuK2lWIRPeU4gnSk8XG6ozxXKUEf7A0xz6xoeqkvzoQ25QyA1UienZ4C-bDdXhnx4xfaEuXizlc8qfi8vLUPPdmsO8_LitqHLFM8tgUQE1UQ8Cm1HE1xmVrZyGGbdzsbVF2flnQRoxAMKOVKe9u6sxRi54rPtTotBjt6xBe_DDXnrce-aDR7MkujRa3QOWM/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=4032&maxHeightPx=2268",
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.facebook.com/kensushi.asianbistro",
      "poi_directions_map_url": "https://maps.google.com/?cid=18073218320259684024&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ken-sushi--asian-bistro",
      "poi_latitude": "27.9602174",
      "poi_longitude": "-82.72147989999999",
      "poi_miles_from_property": "8.5 mi",
      "poi_walking_minutes": "3 hours 10 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 727-315-4902",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad07-75fd-ab81-da780ab3f1b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad07-75fd-ab81-da780ab3f1b6",
        "storage_key": "property/5641831400341504/019f1505-ad07-75fd-ab81-da780ab3f1b6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJDw_mfM7vwogRuBYpZ0740Po",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "ec_aced18d003d71b2c9c84a706",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Capogna's Dugout",
      "poi_type": "Restaurants",
      "poi_address": "1653 Gulf To Bay Blvd, Clearwater, FL 33755, USA",
      "poi_short_description": "Serving pizza & casual Italian fare since 1973 with a separate sports bar & memorabilia-rich walls.",
      "poi_long_description": "Serving pizza & casual Italian fare since 1973 with a separate sports bar & memorabilia-rich walls.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1508-c17b-7423-980c-48a1868264d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-c17b-7423-980c-48a1868264d1",
        "storage_key": "property/5641831400341504/019f1508-c17b-7423-980c-48a1868264d1.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5167370087713122908&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "capognas-dugout",
      "poi_latitude": "27.9597095",
      "poi_longitude": "-82.7687598",
      "poi_miles_from_property": "10.1 mi",
      "poi_walking_minutes": "3 hours 45 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 727-441-4791",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad07-75fd-ab81-da780ab3f1b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad07-75fd-ab81-da780ab3f1b6",
        "storage_key": "property/5641831400341504/019f1505-ad07-75fd-ab81-da780ab3f1b6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0Ss0qlHwwogRXKoehbcvtkc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_86621d1a54fdd69b3fe5d5dc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Publix Super Market at Carillon Town Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "120 Carillon Pkwy, St. Petersburg, FL 33716, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1508-bffa-73ff-a5c7-beecd4cbe404.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-bffa-73ff-a5c7-beecd4cbe404",
        "storage_key": "property/5641831400341504/019f1508-bffa-73ff-a5c7-beecd4cbe404.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=140&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=9461205064126716014&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-carillon-town-center",
      "poi_latitude": "27.8931391",
      "poi_longitude": "-82.6621574",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 727-540-1660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad09-7236-9fba-a09fb98bec9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad09-7236-9fba-a09fb98bec9a",
        "storage_key": "property/5641831400341504/019f1505-ad09-7236-9fba-a09fb98bec9a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV7Utd8LlwogRblhm0uDzTIM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_ebe540c00ced25ea0bc78fdd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "3765 Ulmerton Rd, Clearwater, FL 33762, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1508-b686-731e-a034-a06a3f371c2e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-b686-731e-a034-a06a3f371c2e",
        "storage_key": "property/5641831400341504/019f1508-b686-731e-a034-a06a3f371c2e.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.cvs.com/store-locator/clearwater-fl-pharmacies/3765-ulmerton-rd-clearwater-fl-33762/storeid=3960?WT.mc_id=LS_GOOGLE_RX_3960",
      "poi_directions_map_url": "https://maps.google.com/?cid=10474463222246078755&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "27.8946514",
      "poi_longitude": "-82.68466839999999",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 727-573-3383",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-89f3-70ad-b22a-581501e2768a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1509-89f3-70ad-b22a-581501e2768a",
        "storage_key": "property/5641831400341504/019f1509-89f3-70ad-b22a-581501e2768a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ5TvdKLlwogRI_ne9s3EXJE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_4411e87ec4e928217baa0f3b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Feather Sound Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "2325 Ulmerton Rd #18, Clearwater, FL 33762, USA",
      "poi_short_description": "Business center featuring a gas station, shops, a mall, restaurants, and a hotel.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1508-d3d2-7189-b627-30686d9fca04.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-d3d2-7189-b627-30686d9fca04",
        "storage_key": "property/5641831400341504/019f1508-d3d2-7189-b627-30686d9fca04.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2600967768468926476&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "feather-sound-square",
      "poi_latitude": "27.8944192",
      "poi_longitude": "-82.6674087",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad26-762b-bc5c-832cfc6a7e69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad26-762b-bc5c-832cfc6a7e69",
        "storage_key": "property/5641831400341504/019f1505-ad26-762b-bc5c-832cfc6a7e69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5dwjY-rlwogRDLDUp2d-GCQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "business_center"
    },
    {
      "id": "ec_2c2db88c02757b1ebd630f99",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Panera Bread",
      "poi_type": "Shopping & Retail",
      "poi_address": "2285 Ulmerton Rd, Clearwater, FL 33762, USA",
      "poi_short_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_long_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1508-abfb-7711-84b1-57c743705eae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-abfb-7711-84b1-57c743705eae",
        "storage_key": "property/5641831400341504/019f1508-abfb-7711-84b1-57c743705eae.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.panerabread.com/en-us/cafe/locations/fl/clearwater/2285-ulmerton-road?utm_medium=local&utm_source=google&utm_campaign=dpm-dist&utm_term=203341&utm_content=main",
      "poi_directions_map_url": "https://maps.google.com/?cid=9930602238905074866&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "panera-bread",
      "poi_latitude": "27.894467",
      "poi_longitude": "-82.664842",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 727-592-9690",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-896c-75f1-b25e-ad082fc3a6f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1509-896c-75f1-b25e-ad082fc3a6f9",
        "storage_key": "property/5641831400341504/019f1509-896c-75f1-b25e-ad082fc3a6f9.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJz50NA-rlwogRssSiJx-W0Ik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "ec_4bf94663e90c2ab1ab3907e6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Starbucks Coffee Company",
      "poi_type": "Shopping & Retail",
      "poi_address": "2577 Ulmerton Rd, Clearwater, FL 33762, USA",
      "poi_short_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_long_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1508-c3d8-7656-8f8c-0c5b6046ece7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-c3d8-7656-8f8c-0c5b6046ece7",
        "storage_key": "property/5641831400341504/019f1508-c3d8-7656-8f8c-0c5b6046ece7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.starbucks.com/store-locator/store/14386/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6342820281402160869&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "starbucks-coffee-company",
      "poi_latitude": "27.89431",
      "poi_longitude": "-82.66855",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 727-540-9177",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-896c-75f1-b25e-ad082fc3a6f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1509-896c-75f1-b25e-ad082fc3a6f9",
        "storage_key": "property/5641831400341504/019f1509-896c-75f1-b25e-ad082fc3a6f9.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJHfWxmOrlwogR5XYes3A5Blg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_b1207e6a0b613c9e8e57a620",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "The UPS Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "2655 Ulmerton Rd, Clearwater, FL 33762, USA",
      "poi_short_description": "Store offering shipping, packaging, printing & other services, plus office supplies.",
      "poi_long_description": "Store offering shipping, packaging, printing & other services, plus office supplies.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1508-c1e1-7391-9670-74a330f66d8b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-c1e1-7391-9670-74a330f66d8b",
        "storage_key": "property/5641831400341504/019f1508-c1e1-7391-9670-74a330f66d8b.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://locations.theupsstore.com/fl/clearwater/2655-ulmerton-rd?utm_source=Yext&utm_medium=organic&utm_campaign=Listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=12461707080387564110&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-ups-store",
      "poi_latitude": "27.8944835",
      "poi_longitude": "-82.66937639999999",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 727-556-0500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad26-762b-bc5c-832cfc6a7e69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad26-762b-bc5c-832cfc6a7e69",
        "storage_key": "property/5641831400341504/019f1505-ad26-762b-bc5c-832cfc6a7e69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdeMZ_b_lwogRTpJ4jZDg8Kw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shipping_service"
    },
    {
      "id": "ec_5ded93fb50f24eb900f05799",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Woof Gang Bakery & Grooming Feather Sound",
      "poi_type": "Shopping & Retail",
      "poi_address": "2661 Ulmerton Rd, Clearwater, FL 33762, USA",
      "poi_short_description": "All-natural pet food and treats, plus spa grooming services like nail care and ear cleaning.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1508-cbb7-71a3-989d-5df204f16ce0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-cbb7-71a3-989d-5df204f16ce0",
        "storage_key": "property/5641831400341504/019f1508-cbb7-71a3-989d-5df204f16ce0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://woofgangbakery.com/pages/locations/feather-sound?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=11854123895012651032&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woof-gang-bakery--grooming-feather-sound",
      "poi_latitude": "27.8944046",
      "poi_longitude": "-82.66960259999999",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 727-289-1234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad26-762b-bc5c-832cfc6a7e69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad26-762b-bc5c-832cfc6a7e69",
        "storage_key": "property/5641831400341504/019f1505-ad26-762b-bc5c-832cfc6a7e69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe3upW7LlwogRGPCybeBOgqQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pet_care"
    },
    {
      "id": "ec_2e33c13854977a987cadf6da",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Topgolf Saint Petersburg",
      "poi_type": "Shopping & Retail",
      "poi_address": "220 Carillon Pkwy, St. Petersburg, FL 33716, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-80ab-7609-9925-c91f616a24eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-80ab-7609-9925-c91f616a24eb",
        "storage_key": "property/5641831400341504/019f1505-80ab-7609-9925-c91f616a24eb.webp",
        "width": 1097,
        "height": 1280
      },
      "poi_business_url": "https://topgolf.com/us/st-petersburg/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4569467318132530978&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "topgolf-saint-petersburg",
      "poi_latitude": "27.8892331",
      "poi_longitude": "-82.66248139999999",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 727-870-4030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad07-75fd-ab81-da780ab3f1b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad07-75fd-ab81-da780ab3f1b6",
        "storage_key": "property/5641831400341504/019f1505-ad07-75fd-ab81-da780ab3f1b6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8ch4SeLlwogRIt8L1lACaj8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_7c5f2c415991cef82ce1a9df",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Feather Sound Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "2325 Ulmerton Rd #18, Clearwater, FL 33762, USA",
      "poi_short_description": "Business center featuring a gas station, shops, a mall, restaurants, and a hotel.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1508-d3d2-7189-b627-30686d9fca04.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-d3d2-7189-b627-30686d9fca04",
        "storage_key": "property/5641831400341504/019f1508-d3d2-7189-b627-30686d9fca04.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2600967768468926476&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "feather-sound-square",
      "poi_latitude": "27.8944192",
      "poi_longitude": "-82.6674087",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad26-762b-bc5c-832cfc6a7e69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad26-762b-bc5c-832cfc6a7e69",
        "storage_key": "property/5641831400341504/019f1505-ad26-762b-bc5c-832cfc6a7e69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5dwjY-rlwogRDLDUp2d-GCQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "business_center"
    },
    {
      "id": "ec_9613d48d8935bec8702f6429",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "High Point Elementary School",
      "poi_type": "Education",
      "poi_address": "5921 150th Ave N, Clearwater, FL 33760, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.highpoint-es.pinellas.k12.fl.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12838741305985459331&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "high-point-elementary-school",
      "poi_latitude": "27.9096614",
      "poi_longitude": "-82.7142271",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 727-538-7440",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad33-763b-a248-ab96ca7d2cd7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad33-763b-a248-ab96ca7d2cd7",
        "storage_key": "property/5641831400341504/019f1505-ad33-763b-a248-ab96ca7d2cd7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIzBaRF3lwogRg-Rl-jFfLLI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_dd90deb4b8ff89f429f63651",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Morgan Fitzgerald Middle School",
      "poi_type": "Education",
      "poi_address": "6410 118th Ave N, Largo, FL 33773, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.pcsb.org/fitzgerald-ms",
      "poi_directions_map_url": "https://maps.google.com/?cid=17106086691183346644&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "morgan-fitzgerald-middle-school",
      "poi_latitude": "27.8781427",
      "poi_longitude": "-82.7262172",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 727-547-4526",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad33-763b-a248-ab96ca7d2cd7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad33-763b-a248-ab96ca7d2cd7",
        "storage_key": "property/5641831400341504/019f1505-ad33-763b-a248-ab96ca7d2cd7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZ-Dd7yjlwogR1EMFtTYHZe0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_ccd06fe1f5620be06047a687",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Pinellas Park High School",
      "poi_type": "Education",
      "poi_address": "6305 118th Ave N, Largo, FL 33773, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1508-e11a-778e-8147-7a8590f47e35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-e11a-778e-8147-7a8590f47e35",
        "storage_key": "property/5641831400341504/019f1508-e11a-778e-8147-7a8590f47e35.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.pcsb.org/pp-hs",
      "poi_directions_map_url": "https://maps.google.com/?cid=6229542909984029153&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pinellas-park-high-school",
      "poi_latitude": "27.8807696",
      "poi_longitude": "-82.7238871",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 727-538-7410",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad33-763b-a248-ab96ca7d2cd7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad33-763b-a248-ab96ca7d2cd7",
        "storage_key": "property/5641831400341504/019f1505-ad33-763b-a248-ab96ca7d2cd7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ05A-jCXlwogR4bmmZkXIc1Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_09bdd89a22de483c5b0b916f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Frontier Elementary School",
      "poi_type": "Education",
      "poi_address": "6995 Hopedale Ln, Clearwater, FL 33764, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.pcsb.org/frontier-es",
      "poi_directions_map_url": "https://maps.google.com/?cid=751767795207809712&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "frontier-elementary-school",
      "poi_latitude": "27.910054",
      "poi_longitude": "-82.736605",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 727-538-7335",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad33-763b-a248-ab96ca7d2cd7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad33-763b-a248-ab96ca7d2cd7",
        "storage_key": "property/5641831400341504/019f1505-ad33-763b-a248-ab96ca7d2cd7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZYuvb636wogRsKrwotPQbgo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_f4c6cea3b239fe15c042c1d8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Magnolia Day School of Dunedin",
      "poi_type": "Education",
      "poi_address": "1123 Overcash Dr, Dunedin, FL 34698, USA",
      "poi_short_description": "Day-care center with playgrounds, after-school dance classes, and a focus on keeping parents informed.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1508-d432-7367-856e-ad339bd792f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-d432-7367-856e-ad339bd792f6",
        "storage_key": "property/5641831400341504/019f1508-d432-7367-856e-ad339bd792f6.webp",
        "width": 900,
        "height": 600
      },
      "poi_business_url": "https://magnoliadayschool-dunedin.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3983453156704167321&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "magnolia-day-school-of-dunedin",
      "poi_latitude": "28.020595",
      "poi_longitude": "-82.7549834",
      "poi_miles_from_property": "13.3 mi",
      "poi_walking_minutes": "4 hours 55 mins",
      "poi_biking_minutes": "1 hour 18 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 727-754-9499",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad33-763b-a248-ab96ca7d2cd7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad33-763b-a248-ab96ca7d2cd7",
        "storage_key": "property/5641831400341504/019f1505-ad33-763b-a248-ab96ca7d2cd7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnYuZK2_zwogRmaXCcIoRSDc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_9bf711e69c3339d736b08b8d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Harbor View Creative Learning Center",
      "poi_type": "Education",
      "poi_address": "3245 Executive Dr, Clearwater, FL 33762, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1508-dba7-7138-87d8-722e20270299.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-dba7-7138-87d8-722e20270299",
        "storage_key": "property/5641831400341504/019f1508-dba7-7138-87d8-722e20270299.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.harborviewclcfl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15435707205911305829&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harbor-view-creative-learning-center",
      "poi_latitude": "27.8947778",
      "poi_longitude": "-82.67769109999999",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 727-954-4479",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad33-763b-a248-ab96ca7d2cd7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad33-763b-a248-ab96ca7d2cd7",
        "storage_key": "property/5641831400341504/019f1505-ad33-763b-a248-ab96ca7d2cd7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ1UniaevlwogRZd5HAeylNtY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_10e1ae63a4295e0eb70ff2fa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Feather Sound Church- Clearwater",
      "poi_type": "Education",
      "poi_address": "13880 Feather Sound Dr, Clearwater, FL 33762, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1508-e74a-70fe-b870-796387e39916.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-e74a-70fe-b870-796387e39916",
        "storage_key": "property/5641831400341504/019f1508-e74a-70fe-b870-796387e39916.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://www.feathersoundchurch.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=344389192275369818&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "feather-sound-church--clearwater",
      "poi_latitude": "27.8978786",
      "poi_longitude": "-82.6739112",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 727-573-3544",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-896a-764f-be70-f56e72352458.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1509-896a-764f-be70-f56e72352458",
        "storage_key": "property/5641831400341504/019f1509-896a-764f-be70-f56e72352458.webp",
        "width": 144,
        "height": 192
      },
      "poi_google_place_id": "ChIJZYoASJTlwogRWp8OTiWExwQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "church"
    },
    {
      "id": "ec_bb810860ffaed60b2ce0ac03",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Bliss Learning Center",
      "poi_type": "Education",
      "poi_address": "16120 Bay Vista Dr, Clearwater, FL 33760, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1508-d751-7648-9729-0704775fa705.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-d751-7648-9729-0704775fa705",
        "storage_key": "property/5641831400341504/019f1508-d751-7648-9729-0704775fa705.webp",
        "width": 1094,
        "height": 1094
      },
      "poi_business_url": "https://www.blisslearningcenters.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11083392757909586395&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bliss-learning-center",
      "poi_latitude": "27.9191836",
      "poi_longitude": "-82.7089513",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 727-531-0081",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad33-763b-a248-ab96ca7d2cd7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad33-763b-a248-ab96ca7d2cd7",
        "storage_key": "property/5641831400341504/019f1505-ad33-763b-a248-ab96ca7d2cd7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJm8EVGhblwogR24FWsf0e0Jk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_4b7dd299d55bef063122e7a7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "St. Petersburg College (SPC) - Clearwater Campus",
      "poi_type": "Education",
      "poi_address": "2465 Drew St, Clearwater, FL 33765, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-8a04-76e5-b090-c9c4c285dab1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-8a04-76e5-b090-c9c4c285dab1",
        "storage_key": "property/5641831400341504/019f1505-8a04-76e5-b090-c9c4c285dab1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.spcollege.edu/friends-partners/about/locations/clearwater-campus",
      "poi_directions_map_url": "https://maps.google.com/?cid=2848272345278873405&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-petersburg-college-spc---clearwater-campus",
      "poi_latitude": "27.9651965",
      "poi_longitude": "-82.73540179999999",
      "poi_miles_from_property": "8.7 mi",
      "poi_walking_minutes": "3 hours 14 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 727-341-4772",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad33-763b-a248-ab96ca7d2cd7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad33-763b-a248-ab96ca7d2cd7",
        "storage_key": "property/5641831400341504/019f1505-ad33-763b-a248-ab96ca7d2cd7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJyVI04EPlwogRPX_qc5sYhyc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_01b3283e77d5538e8eb38e72",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Pinellas Technical College - Clearwater Campus",
      "poi_type": "Education",
      "poi_address": "6100 154th Ave N, Clearwater, FL 33760, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1508-f446-7529-944d-ac2dd3931bf6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-f446-7529-944d-ac2dd3931bf6",
        "storage_key": "property/5641831400341504/019f1508-f446-7529-944d-ac2dd3931bf6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://clearwater.myptc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7731218308683199646&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pinellas-technical-college---clearwater-campus",
      "poi_latitude": "27.911382",
      "poi_longitude": "-82.7201504",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 727-538-7167",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad33-763b-a248-ab96ca7d2cd7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad33-763b-a248-ab96ca7d2cd7",
        "storage_key": "property/5641831400341504/019f1505-ad33-763b-a248-ab96ca7d2cd7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_5A-yczlwogRnvQOChfOSms",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "ec_26a107765afc83cfb62156cd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "The BayCare Sound",
      "poi_type": "Entertainment",
      "poi_address": "255 Drew St, Clearwater, FL 33755, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1508-edee-70be-8971-557b8d37aaa1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-edee-70be-8971-557b8d37aaa1",
        "storage_key": "property/5641831400341504/019f1508-edee-70be-8971-557b8d37aaa1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.thebaycaresound.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12256952656990915394&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-baycare-sound",
      "poi_latitude": "27.9675165",
      "poi_longitude": "-82.80273059999999",
      "poi_miles_from_property": "12.6 mi",
      "poi_walking_minutes": "4 hours 41 mins",
      "poi_biking_minutes": "1 hour 11 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 727-791-7400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad26-762b-bc5c-832cfc6a7e69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad26-762b-bc5c-832cfc6a7e69",
        "storage_key": "property/5641831400341504/019f1505-ad26-762b-bc5c-832cfc6a7e69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnW4wY-TxwogRQku5XIBxGao",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "ec_d153c3ae8f950cf0b17ef2f0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Ruth Eckerd Hall",
      "poi_type": "Entertainment",
      "poi_address": "1111 McMullen Booth Rd, Clearwater, FL 33759, USA",
      "poi_short_description": "Roomy, modern setting for a slate of music, comedy & Broadway shows, plus arts education.",
      "poi_long_description": "Roomy, modern setting for a slate of music, comedy & Broadway shows, plus arts education.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1508-ee6e-7548-9b92-a3dffcf23b53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-ee6e-7548-9b92-a3dffcf23b53",
        "storage_key": "property/5641831400341504/019f1508-ee6e-7548-9b92-a3dffcf23b53.webp",
        "width": 1280,
        "height": 772
      },
      "poi_business_url": "http://www.rutheckerdhall.com/?utm_sorce=google&utm_medium=organic&utm_campaign=googlemybusiness",
      "poi_directions_map_url": "https://maps.google.com/?cid=6247959374876517035&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ruth-eckerd-hall",
      "poi_latitude": "27.9759724",
      "poi_longitude": "-82.7047268",
      "poi_miles_from_property": "10.7 mi",
      "poi_walking_minutes": "3 hours 57 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 727-791-7400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad26-762b-bc5c-832cfc6a7e69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad26-762b-bc5c-832cfc6a7e69",
        "storage_key": "property/5641831400341504/019f1505-ad26-762b-bc5c-832cfc6a7e69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4YG1mE_uwogRqyKWxvI1tVY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_57c2e75790075f26e0f6b3f0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Nancy and David Bilheimer Capitol Theatre",
      "poi_type": "Entertainment",
      "poi_address": "405 Cleveland St, Clearwater, FL 33755, USA",
      "poi_short_description": "Art deco-style venue hosting a mix of events, from comedy acts to musicals, plus film screenings.",
      "poi_long_description": "Art deco-style venue hosting a mix of events, from comedy acts to musicals, plus film screenings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-406b-74a8-87c3-f09f267e82a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-406b-74a8-87c3-f09f267e82a3",
        "storage_key": "property/5641831400341504/019f1509-406b-74a8-87c3-f09f267e82a3.webp",
        "width": 1280,
        "height": 713
      },
      "poi_business_url": "https://www.rutheckerdhall.com/plan-your-visit/the-nancy-and-david-bilheimer-capitol-theatre",
      "poi_directions_map_url": "https://maps.google.com/?cid=4479849667899092482&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nancy-and-david-bilheimer-capitol-theatre",
      "poi_latitude": "27.9654622",
      "poi_longitude": "-82.8009342",
      "poi_miles_from_property": "12.3 mi",
      "poi_walking_minutes": "4 hours 35 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 727-791-7400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad26-762b-bc5c-832cfc6a7e69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad26-762b-bc5c-832cfc6a7e69",
        "storage_key": "property/5641831400341504/019f1505-ad26-762b-bc5c-832cfc6a7e69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4_qkc97wwogRAu5GpomfKz4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_ade4c3eb99af6e93aae0ed82",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Clearwater Marine Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "249 Windward Passage, Clearwater, FL 33767, USA",
      "poi_short_description": "Home of the inspiration for \"Dolphin Tale,\" this aquarium exhibits marine mammals & sea turtles.",
      "poi_long_description": "Home of the inspiration for \"Dolphin Tale,\" this aquarium exhibits marine mammals & sea turtles.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-0ecc-753b-8de8-f4504bd965b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-0ecc-753b-8de8-f4504bd965b7",
        "storage_key": "property/5641831400341504/019f1509-0ecc-753b-8de8-f4504bd965b7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cmaquarium.org/?utm_source=googlemybusiness&utm_medium=listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=9796862436512290579&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clearwater-marine-aquarium",
      "poi_latitude": "27.9769348",
      "poi_longitude": "-82.8176984",
      "poi_miles_from_property": "13.7 mi",
      "poi_walking_minutes": "5 hours 7 mins",
      "poi_biking_minutes": "1 hour 16 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 727-441-1790",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad26-762b-bc5c-832cfc6a7e69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad26-762b-bc5c-832cfc6a7e69",
        "storage_key": "property/5641831400341504/019f1505-ad26-762b-bc5c-832cfc6a7e69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiZrtZSvxwogRE9eu4Xpy9Yc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "ec_21c49294629b4e0a58cc990e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Pier 60 Clearwater",
      "poi_type": "Entertainment",
      "poi_address": "1 Causeway Blvd, Clearwater Beach, FL 33767, USA",
      "poi_short_description": "Lively boardwalk, popular for sunset views & fishing, with entertainers & artisanal craft stalls.",
      "poi_long_description": "Lively boardwalk, popular for sunset views & fishing, with entertainers & artisanal craft stalls.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-049b-71bf-abfe-2290203fc8cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-049b-71bf-abfe-2290203fc8cc",
        "storage_key": "property/5641831400341504/019f1509-049b-71bf-abfe-2290203fc8cc.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.visitstpeteclearwater.com/profile/pier-60-clearwater-beach/139755",
      "poi_directions_map_url": "https://maps.google.com/?cid=2791687222424203799&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pier-60-clearwater",
      "poi_latitude": "27.9770797",
      "poi_longitude": "-82.8281664",
      "poi_miles_from_property": "14.3 mi",
      "poi_walking_minutes": "5 hours 18 mins",
      "poi_biking_minutes": "1 hour 19 mins",
      "poi_driving_minutes": "31 mins",
      "poi_business_phone": "+1 727-871-8060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad26-762b-bc5c-832cfc6a7e69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad26-762b-bc5c-832cfc6a7e69",
        "storage_key": "property/5641831400341504/019f1505-ad26-762b-bc5c-832cfc6a7e69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhS6CJtf2wogRF3KX4LwQviY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fishing_pier"
    },
    {
      "id": "ec_0df9681d2216411684152094",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Clearwater Threshers",
      "poi_type": "Entertainment",
      "poi_address": "601 Old Coachman Rd., Clearwater, FL 33765, USA",
      "poi_short_description": "Stadium hosting spring training games for the Philadelphia Phillies and Clearwater Jazz Holiday, as well as fireworks.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-02b9-77ed-8451-fe5dc6586252.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-02b9-77ed-8451-fe5dc6586252",
        "storage_key": "property/5641831400341504/019f1509-02b9-77ed-8451-fe5dc6586252.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.threshersbaseball.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=742843336731204491&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clearwater-threshers",
      "poi_latitude": "27.9709213",
      "poi_longitude": "-82.7317194",
      "poi_miles_from_property": "8.8 mi",
      "poi_walking_minutes": "3 hours 17 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 727-712-4300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-896c-75f1-b25e-b008d8fd5132.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1509-896c-75f1-b25e-b008d8fd5132",
        "storage_key": "property/5641831400341504/019f1509-896c-75f1-b25e-b008d8fd5132.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJH0k8TCruwogRixuhORQcTwo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "ec_ba71e88ccd50872eb13cf9f5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "The Dalí Museum",
      "poi_type": "Entertainment",
      "poi_address": "1 Dali Blvd, St. Petersburg, FL 33701, USA",
      "poi_short_description": "Extensive collection of surrealist art by Salvador Dalí housed in a building with 900 glass panels.",
      "poi_long_description": "Extensive collection of surrealist art by Salvador Dalí housed in a building with 900 glass panels.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-01e1-773f-9a5c-d0c3e3aa9708.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-01e1-773f-9a5c-d0c3e3aa9708",
        "storage_key": "property/5641831400341504/019f1509-01e1-773f-9a5c-d0c3e3aa9708.webp",
        "width": 480,
        "height": 360
      },
      "poi_business_url": "https://thedali.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2827016530403578629&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-dal-museum",
      "poi_latitude": "27.7659086",
      "poi_longitude": "-82.6315789",
      "poi_miles_from_property": "10.6 mi",
      "poi_walking_minutes": "4 hours 0 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 727-823-3767",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad3b-77ce-9782-67c18855371c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad3b-77ce-9782-67c18855371c",
        "storage_key": "property/5641831400341504/019f1505-ad3b-77ce-9782-67c18855371c.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJyaCQzpHhwogRBdPcZI6UOyc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_448454f57e023aafa39d917e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Leepa-Rattner Museum of Art (LRMA) at St. Petersburg College",
      "poi_type": "Entertainment",
      "poi_address": "600 E Klosterman Rd, Tarpon Springs, FL 34689, USA",
      "poi_short_description": "Sizable collection of 20th-century art, including much by Abraham Rattner, plus many modern masters.",
      "poi_long_description": "Sizable collection of 20th-century art, including much by Abraham Rattner, plus many modern masters.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-02d3-7780-91c9-3c16de351c4a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-02d3-7780-91c9-3c16de351c4a",
        "storage_key": "property/5641831400341504/019f1509-02d3-7780-91c9-3c16de351c4a.webp",
        "width": 494,
        "height": 276
      },
      "poi_business_url": "http://www.leeparattner.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16865321412249520888&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "leepa-rattner-museum-of-art-lrma-at-st-petersburg-college",
      "poi_latitude": "28.121748",
      "poi_longitude": "-82.74647399999999",
      "poi_miles_from_property": "20.0 mi",
      "poi_walking_minutes": "7 hours 22 mins",
      "poi_biking_minutes": "1 hour 48 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 727-712-5762",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad3b-77ce-9782-67c18855371c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad3b-77ce-9782-67c18855371c",
        "storage_key": "property/5641831400341504/019f1505-ad3b-77ce-9782-67c18855371c.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJLa-4KEWNwogR-Ars13eoDeo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_2cecfa4c1dfe5b52947682b7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "CMX Cinemas Countryside 12",
      "poi_type": "Entertainment",
      "poi_address": "27001 US Hwy 19 N #2100, Clearwater, FL 33761, USA",
      "poi_short_description": "Well-appointed multiplex chain featuring digital projection & stadium seating; some offer IMAX & 3D.",
      "poi_long_description": "Well-appointed multiplex chain featuring digital projection & stadium seating; some offer IMAX & 3D.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-1a75-72d8-9b0f-a1ebd41a63b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-1a75-72d8-9b0f-a1ebd41a63b8",
        "storage_key": "property/5641831400341504/019f1509-1a75-72d8-9b0f-a1ebd41a63b8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cmxcinemas.com/Showtimes/Countryside-12",
      "poi_directions_map_url": "https://maps.google.com/?cid=10206844248923175047&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cmx-cinemas-countryside-12",
      "poi_latitude": "28.0169269",
      "poi_longitude": "-82.7348998",
      "poi_miles_from_property": "12.1 mi",
      "poi_walking_minutes": "4 hours 33 mins",
      "poi_biking_minutes": "1 hour 11 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 727-683-0009",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-8a4a-73dc-9e24-89052c14648b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1509-8a4a-73dc-9e24-89052c14648b",
        "storage_key": "property/5641831400341504/019f1509-8a4a-73dc-9e24-89052c14648b.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJQwijfwDywogRh_jNJsT-pY0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_f58f56952325a674c1183461",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Clearwater Historical Society Museum and Cultural Center",
      "poi_type": "Entertainment",
      "poi_address": "610 S Ft Harrison Ave, Clearwater, FL 33756, USA",
      "poi_short_description": "Local history museum with exhibits on multiple aspects of Clearwater's past and free admission.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-11a0-77bb-b51a-4b06450b1a78.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-11a0-77bb-b51a-4b06450b1a78",
        "storage_key": "property/5641831400341504/019f1509-11a0-77bb-b51a-4b06450b1a78.webp",
        "width": 1258,
        "height": 1280
      },
      "poi_business_url": "https://www.clearwaterhistoricalsociety.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12740561765925540364&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clearwater-historical-society-museum-and-cultural-center",
      "poi_latitude": "27.9586469",
      "poi_longitude": "-82.800472",
      "poi_miles_from_property": "11.8 mi",
      "poi_walking_minutes": "4 hours 25 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 727-754-8019",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad3b-77ce-9782-67c18855371c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad3b-77ce-9782-67c18855371c",
        "storage_key": "property/5641831400341504/019f1505-ad3b-77ce-9782-67c18855371c.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJYTwoxK_xwogRDFLqeGyRz7A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_1dac084e65b629d7b8e375af",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Mease Countryside Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "3231 McMullen Booth Rd, Safety Harbor, FL 34695, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-16aa-71bc-9626-34926de95e62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-16aa-71bc-9626-34926de95e62",
        "storage_key": "property/5641831400341504/019f1509-16aa-71bc-9626-34926de95e62.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://baycare.org/hospitals/mease-countryside-hospital/patients-and-visitors?utm_campaign=BayCare_DigitalMarketing_M20140288&utm_source=Google&utm_medium=LocalListing&utm_content=Mease_Countryside_Hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=13889236478498578986&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mease-countryside-hospital",
      "poi_latitude": "28.039268",
      "poi_longitude": "-82.70704289999999",
      "poi_miles_from_property": "14.7 mi",
      "poi_walking_minutes": "5 hours 28 mins",
      "poi_biking_minutes": "1 hour 23 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 727-725-6111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad09-7236-9fba-9def2adec380.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad09-7236-9fba-9def2adec380",
        "storage_key": "property/5641831400341504/019f1505-ad09-7236-9fba-9def2adec380.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJGXlF37jtwogRKiJOJv16wMA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_44cba7b84657fd90ab8b89cc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "BayCare Urgent Care (Countryside)",
      "poi_type": "Health and Wellness",
      "poi_address": "3351 McMullen Booth Rd, Clearwater, FL 33761, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-1882-76bb-a416-9a8dc66728f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-1882-76bb-a416-9a8dc66728f8",
        "storage_key": "property/5641831400341504/019f1509-1882-76bb-a416-9a8dc66728f8.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://baycare.org/locations/b/baycare-urgent-care-countryside?utm_campaign=BayCare_DigitalMarketing_M20140288&utm_source=Google&utm_medium=LocalListing&utm_content=BayCare_Urgent_Care_(Countryside)",
      "poi_directions_map_url": "https://maps.google.com/?cid=6105842455170788908&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baycare-urgent-care-countryside",
      "poi_latitude": "28.0428127",
      "poi_longitude": "-82.7085154",
      "poi_miles_from_property": "14.8 mi",
      "poi_walking_minutes": "5 hours 29 mins",
      "poi_biking_minutes": "1 hour 23 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 727-314-4774",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad26-762b-bc5c-832cfc6a7e69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad26-762b-bc5c-832cfc6a7e69",
        "storage_key": "property/5641831400341504/019f1505-ad26-762b-bc5c-832cfc6a7e69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoZWWb7ztwogRLC704lxPvFQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_c1e93d71fae5191e207680fd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Morton Plant Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "300 Pinellas St, Clearwater, FL 33756, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-1129-7768-8d1f-62d4c7b81b66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-1129-7768-8d1f-62d4c7b81b66",
        "storage_key": "property/5641831400341504/019f1509-1129-7768-8d1f-62d4c7b81b66.webp",
        "width": 1000,
        "height": 676
      },
      "poi_business_url": "https://baycare.org/hospitals/morton-plant-hospital/patients-and-visitors?utm_campaign=BayCare_DigitalMarketing_M20140288&utm_source=Google&utm_medium=LocalListing&utm_content=Morton_Plant_Hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=3251150992652485143&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "morton-plant-hospital",
      "poi_latitude": "27.9529483",
      "poi_longitude": "-82.8037102",
      "poi_miles_from_property": "11.6 mi",
      "poi_walking_minutes": "4 hours 20 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 727-462-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad09-7236-9fba-9def2adec380.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad09-7236-9fba-9def2adec380",
        "storage_key": "property/5641831400341504/019f1505-ad09-7236-9fba-9def2adec380.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ60HWOMHwwogRF8I1PJpoHi0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_eb48c09b01a90385602b3076",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "3765 Ulmerton Rd, Clearwater, FL 33762, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1508-b686-731e-a034-a06a3f371c2e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1508-b686-731e-a034-a06a3f371c2e",
        "storage_key": "property/5641831400341504/019f1508-b686-731e-a034-a06a3f371c2e.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.cvs.com/store-locator/clearwater-fl-pharmacies/3765-ulmerton-rd-clearwater-fl-33762/storeid=3960?WT.mc_id=LS_GOOGLE_RX_3960",
      "poi_directions_map_url": "https://maps.google.com/?cid=10474463222246078755&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "27.8946514",
      "poi_longitude": "-82.68466839999999",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 727-573-3383",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-89f3-70ad-b22a-581501e2768a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1509-89f3-70ad-b22a-581501e2768a",
        "storage_key": "property/5641831400341504/019f1509-89f3-70ad-b22a-581501e2768a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ5TvdKLlwogRI_ne9s3EXJE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_aac0131d2ebb869b9fc7c164",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Publix Pharmacy at Bayside Bridge Plaza",
      "poi_type": "Health and Wellness",
      "poi_address": "1520 McMullen Booth Rd, Clearwater, FL 33759, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-1648-73e7-b8dc-7e89dfbb4525.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-1648-73e7-b8dc-7e89dfbb4525",
        "storage_key": "property/5641831400341504/019f1509-1648-73e7-b8dc-7e89dfbb4525.webp",
        "width": 550,
        "height": 550
      },
      "poi_business_url": "https://www.publix.com/pharmacy?utm_medium=maps&utm_source=google&utm_content=psmpharm_google_override",
      "poi_directions_map_url": "https://maps.google.com/?cid=5012861564381104193&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-pharmacy-at-bayside-bridge-plaza",
      "poi_latitude": "27.9800344",
      "poi_longitude": "-82.7109941",
      "poi_miles_from_property": "10.6 mi",
      "poi_walking_minutes": "3 hours 57 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 727-726-1061",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-89f3-70ad-b22a-581501e2768a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1509-89f3-70ad-b22a-581501e2768a",
        "storage_key": "property/5641831400341504/019f1509-89f3-70ad-b22a-581501e2768a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPRwgAkfuwogRQQgllQhDkUU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_c2bdb032aa82c2659e16cac7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "1701 McMullen Booth Rd, Clearwater, FL 33759, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-1ae4-7414-ba81-fb957aa32b8e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-1ae4-7414-ba81-fb957aa32b8e",
        "storage_key": "property/5641831400341504/019f1509-1ae4-7414-ba81-fb957aa32b8e.webp",
        "width": 1280,
        "height": 592
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1701+n+mcmullen+booth+rd-clearwater-fl-33759/id=9688",
      "poi_directions_map_url": "https://maps.google.com/?cid=8805625648333614372&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "27.9830137",
      "poi_longitude": "-82.707983",
      "poi_miles_from_property": "10.7 mi",
      "poi_walking_minutes": "3 hours 58 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 727-726-3870",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad26-762b-bc5c-832cfc6a7e69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad26-762b-bc5c-832cfc6a7e69",
        "storage_key": "property/5641831400341504/019f1505-ad26-762b-bc5c-832cfc6a7e69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb95cqUbuwogRJG3-ed_dM3o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_77f5042e1e76b44cd05bcfea",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2522 McMullen Booth Rd, Clearwater, FL 33761, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-1ee4-76fd-b260-0dff5cbe9712.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-1ee4-76fd-b260-0dff5cbe9712",
        "storage_key": "property/5641831400341504/019f1509-1ee4-76fd-b260-0dff5cbe9712.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/clearwater-florida-920/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=920",
      "poi_directions_map_url": "https://maps.google.com/?cid=7805366111624027111&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "28.014037",
      "poi_longitude": "-82.7113195",
      "poi_miles_from_property": "12.8 mi",
      "poi_walking_minutes": "4 hours 46 mins",
      "poi_biking_minutes": "1 hour 15 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 727-712-1575",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad26-762b-bc5c-832cfc6a7e69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad26-762b-bc5c-832cfc6a7e69",
        "storage_key": "property/5641831400341504/019f1505-ad26-762b-bc5c-832cfc6a7e69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-8UPXt_twogR59s4uR87Umw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_5cf88ce6a9a1c089c5a10a04",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Crunch Fitness - Countryside",
      "poi_type": "Health and Wellness",
      "poi_address": "2591 FL-580, Clearwater, FL 33761, USA",
      "poi_short_description": "Spacious environment for fitness featuring cardio machines, a sauna and free weights.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-2450-7795-a1ab-7bbe4dbfd2bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-2450-7795-a1ab-7bbe4dbfd2bc",
        "storage_key": "property/5641831400341504/019f1509-2450-7795-a1ab-7bbe4dbfd2bc.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "https://www.crunch.com/locations/countryside",
      "poi_directions_map_url": "https://maps.google.com/?cid=482505360422231246&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crunch-fitness---countryside",
      "poi_latitude": "28.0188792",
      "poi_longitude": "-82.7302466",
      "poi_miles_from_property": "12.2 mi",
      "poi_walking_minutes": "4 hours 35 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 727-509-3033",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad26-762b-bc5c-832cfc6a7e69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad26-762b-bc5c-832cfc6a7e69",
        "storage_key": "property/5641831400341504/019f1505-ad26-762b-bc5c-832cfc6a7e69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFTY1XoHtwogRzlwwohE0sgY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_2eb032206abd3d1418bb5f82",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Club Pilates",
      "poi_type": "Health and Wellness",
      "poi_address": "25973 US-19 Ste. A-102, Clearwater, FL 33763, USA",
      "poi_short_description": "Pilates studio offering reformer fusion classes for all ages and fitness levels.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-2319-7728-8939-82e411b6b031.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-2319-7728-8939-82e411b6b031",
        "storage_key": "property/5641831400341504/019f1509-2319-7728-8939-82e411b6b031.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.clubpilates.com/countryside/?utm_source=google.com&utm_medium=referral&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=17127798096203668843&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "club-pilates",
      "poi_latitude": "28.0085785",
      "poi_longitude": "-82.72903339999999",
      "poi_miles_from_property": "11.4 mi",
      "poi_walking_minutes": "4 hours 17 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 727-210-5365",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad33-763b-a248-ab96ca7d2cd7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad33-763b-a248-ab96ca7d2cd7",
        "storage_key": "property/5641831400341504/019f1505-ad33-763b-a248-ab96ca7d2cd7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ7xMI8ADywogRa93UHJ8psu0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_06a4ba6e3d120080e50a96d2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Feather Sound Country Club",
      "poi_type": "Health and Wellness",
      "poi_address": "2201 Feather Sound Dr, Clearwater, FL 33762, USA",
      "poi_short_description": "Private country club featuring a golf course, tennis courts and a pool.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-2ce7-746b-bff7-3fd4e9a6a85a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-2ce7-746b-bff7-3fd4e9a6a85a",
        "storage_key": "property/5641831400341504/019f1509-2ce7-746b-bff7-3fd4e9a6a85a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.fscc.club/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17226245561694867390&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "feather-sound-country-club",
      "poi_latitude": "27.898481",
      "poi_longitude": "-82.66448199999999",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 727-573-5666",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad26-762b-bc5c-832cfc6a7e69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad26-762b-bc5c-832cfc6a7e69",
        "storage_key": "property/5641831400341504/019f1505-ad26-762b-bc5c-832cfc6a7e69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB4jPZ-nlwogRvs943hHrD-8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "ec_45e52215e315d4758f7bded1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Enterprise Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2655 Enterprise Rd E, Clearwater, FL 33759, USA",
      "poi_short_description": "Popular, spacious dog park boasting off-leash trails, agility areas and water stations.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-3122-706d-8f89-c7521b766b1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-3122-706d-8f89-c7521b766b1d",
        "storage_key": "property/5641831400341504/019f1509-3122-706d-8f89-c7521b766b1d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.myclearwater.com/Neighborhood-Map-Locations/Parks-Trails-and-Recreation-Centers/Enterprise-Dog-Park?lang_update=638525148960899082",
      "poi_directions_map_url": "https://maps.google.com/?cid=2884408685206709913&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "enterprise-dog-park",
      "poi_latitude": "28.0103711",
      "poi_longitude": "-82.72694489999999",
      "poi_miles_from_property": "11.7 mi",
      "poi_walking_minutes": "4 hours 22 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 727-562-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad44-742a-9471-71253729fed9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad44-742a-9471-71253729fed9",
        "storage_key": "property/5641831400341504/019f1505-ad44-742a-9471-71253729fed9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJlapnWQbuwogRmSbMvGp6Byg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "ec_80c958a8cca966f3a1ddfd8e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Moccasin Lake Nature Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2750 Park Trail Ln, Clearwater, FL 33759, USA",
      "poi_short_description": "Tranquil, oak-lined paths, educational walking tours, natural exhibits & educational kids' camps.",
      "poi_long_description": "Tranquil, oak-lined paths, educational walking tours, natural exhibits & educational kids' camps.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-3580-72cc-84f7-e17649b852b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-3580-72cc-84f7-e17649b852b6",
        "storage_key": "property/5641831400341504/019f1509-3580-72cc-84f7-e17649b852b6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.myclearwaterparks.com/Parks-and-Trails/Moccasin-Lake-Nature-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=5715221487005762077&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "moccasin-lake-nature-park",
      "poi_latitude": "27.975749",
      "poi_longitude": "-82.723432",
      "poi_miles_from_property": "9.6 mi",
      "poi_walking_minutes": "3 hours 33 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 727-562-4315",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad44-742a-9471-71253729fed9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad44-742a-9471-71253729fed9",
        "storage_key": "property/5641831400341504/019f1505-ad44-742a-9471-71253729fed9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJIX-j5y_uwogRHYKocamLUE8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "ec_0ee98bd25b3b33c22ea3809e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Frank Tack Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1967 N Hercules Ave, Clearwater, FL 33763, USA",
      "poi_short_description": "Baseball fields well suited for adults and children alike.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-2da8-702d-936c-9cf85c6463c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-2da8-702d-936c-9cf85c6463c6",
        "storage_key": "property/5641831400341504/019f1509-2da8-702d-936c-9cf85c6463c6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.myclearwater.com/Home/Components/FacilityDirectory/FacilityDirectory/345/265?npage=5",
      "poi_directions_map_url": "https://maps.google.com/?cid=9199344379790584045&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "frank-tack-park",
      "poi_latitude": "27.991818",
      "poi_longitude": "-82.75357900000002",
      "poi_miles_from_property": "11.6 mi",
      "poi_walking_minutes": "4 hours 18 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 727-462-6137",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad44-742a-9471-71253729fed9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad44-742a-9471-71253729fed9",
        "storage_key": "property/5641831400341504/019f1505-ad44-742a-9471-71253729fed9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkWIFfurxwogR7WjnI_miqn8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_017590d8c9477b3ba3ff6bc2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Achieva Paw Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1659 Achieva Way, Dunedin, FL 34698, USA",
      "poi_short_description": "Park featuring fenced-off areas for big and small dogs, plus a kiddie pool and a hose.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-3505-71d2-a10d-3d6743af2210.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-3505-71d2-a10d-3d6743af2210",
        "storage_key": "property/5641831400341504/019f1509-3505-71d2-a10d-3d6743af2210.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.dunedin.gov/Activities-and-Recreation/Parks-Recreation/Parks-Playgrounds/Achieva-Paw-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=10536935726247327666&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "achieva-paw-park",
      "poi_latitude": "28.0161499",
      "poi_longitude": "-82.75840099999999",
      "poi_miles_from_property": "13.7 mi",
      "poi_walking_minutes": "5 hours 4 mins",
      "poi_biking_minutes": "1 hour 16 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 727-431-7597",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad44-742a-9471-71253729fed9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad44-742a-9471-71253729fed9",
        "storage_key": "property/5641831400341504/019f1505-ad44-742a-9471-71253729fed9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJgfg5RyDywogRsjcYSDe3OpI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "ec_a30b76ed3040f2ce4f976d24",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Hammock Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1900 San Mateo Dr, Dunedin, FL 34698, USA",
      "poi_short_description": "Tranquil nature preserve home to century-old trees & a butterfly garden with 225 plant species.",
      "poi_long_description": "Tranquil nature preserve home to century-old trees & a butterfly garden with 225 plant species.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-35da-7159-920c-91087ee9eb8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-35da-7159-920c-91087ee9eb8d",
        "storage_key": "property/5641831400341504/019f1509-35da-7159-920c-91087ee9eb8d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dunedin.gov/Activities-and-Recreation/Parks-Recreation/Parks-Playgrounds/Hammock-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=10235695397081978181&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hammock-park",
      "poi_latitude": "28.0327741",
      "poi_longitude": "-82.7812694",
      "poi_miles_from_property": "16.2 mi",
      "poi_walking_minutes": "6 hours 0 mins",
      "poi_biking_minutes": "1 hour 40 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 727-812-4530",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad44-742a-9471-71253729fed9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad44-742a-9471-71253729fed9",
        "storage_key": "property/5641831400341504/019f1505-ad44-742a-9471-71253729fed9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJifq_i8vzwogRRRUsjLt-DI4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_95362c69ea704542a8964bc6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Philippe Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2525 Philippe Pkwy, Safety Harbor, FL 34695, USA",
      "poi_short_description": "Tranquil harborside park with a historic Native American mound, a playground, fishing & more.",
      "poi_long_description": "Tranquil harborside park with a historic Native American mound, a playground, fishing & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-3526-72ed-8c18-0a368d3565ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-3526-72ed-8c18-0a368d3565ef",
        "storage_key": "property/5641831400341504/019f1509-3526-72ed-8c18-0a368d3565ef.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.pinellascounty.org/park/11_philippe.htm",
      "poi_directions_map_url": "https://maps.google.com/?cid=8656615983054769851&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "philippe-park",
      "poi_latitude": "28.0086487",
      "poi_longitude": "-82.6796507",
      "poi_miles_from_property": "13.5 mi",
      "poi_walking_minutes": "4 hours 59 mins",
      "poi_biking_minutes": "1 hour 13 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad44-742a-9471-71253729fed9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad44-742a-9471-71253729fed9",
        "storage_key": "property/5641831400341504/019f1505-ad44-742a-9471-71253729fed9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJNedJ7ZzuwogRu87yMl96Ing",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_6d6bd4cae0ac0c3121496109",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Sawgrass Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7400 25th St N, St. Petersburg, FL 33702, USA",
      "poi_short_description": "Swamp conservation area with a mile-long boardwalk & a 1/2-mile dirt path for wildlife observation.",
      "poi_long_description": "Swamp conservation area with a mile-long boardwalk & a 1/2-mile dirt path for wildlife observation.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-9fd9-710e-b07a-2b4d388957b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-9fd9-710e-b07a-2b4d388957b9",
        "storage_key": "property/5641831400341504/019f1505-9fd9-710e-b07a-2b4d388957b9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.pinellascounty.org/park/16_Sawgrass.htm",
      "poi_directions_map_url": "https://maps.google.com/?cid=16202851700045047919&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sawgrass-lake-park",
      "poi_latitude": "27.8379308",
      "poi_longitude": "-82.6674635",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 727-582-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad44-742a-9471-71253729fed9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad44-742a-9471-71253729fed9",
        "storage_key": "property/5641831400341504/019f1505-ad44-742a-9471-71253729fed9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJdV_TKm3kwogRb-iEWcYX3OA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_e46ac9af23047075493d9c71",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Wall Springs Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "465G+M2, 3725 Desoto Blvd, Palm Harbor, FL 34683, USA",
      "poi_short_description": "Natural area with bayou views, walking paths, an observation tower & a playground.",
      "poi_long_description": "Natural area with bayou views, walking paths, an observation tower & a playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-43f3-77ca-9282-23fd53809d51.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-43f3-77ca-9282-23fd53809d51",
        "storage_key": "property/5641831400341504/019f1509-43f3-77ca-9282-23fd53809d51.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.pinellascounty.org/park/21_Wall_Springs.htm",
      "poi_directions_map_url": "https://maps.google.com/?cid=16250391139471649241&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wall-springs-park",
      "poi_latitude": "28.10685",
      "poi_longitude": "-82.7714252",
      "poi_miles_from_property": "20.0 mi",
      "poi_walking_minutes": "7 hours 22 mins",
      "poi_biking_minutes": "1 hour 53 mins",
      "poi_driving_minutes": "33 mins",
      "poi_business_phone": "+1 727-582-5590",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad44-742a-9471-71253729fed9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad44-742a-9471-71253729fed9",
        "storage_key": "property/5641831400341504/019f1505-ad44-742a-9471-71253729fed9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJgX1tnNTywogR2elcoaT8hOE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_820d2e78d434a03ea1a37685",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Upper Tampa Bay Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8001 Double Branch Rd, Tampa, FL 33635, USA",
      "poi_short_description": "Scenic preserve featuring trails, picnic areas, a nature center & canoe/kayak launch on the bay.",
      "poi_long_description": "Scenic preserve featuring trails, picnic areas, a nature center & canoe/kayak launch on the bay.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-4d62-73d8-bed7-c1c80b0d5bf2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-4d62-73d8-bed7-c1c80b0d5bf2",
        "storage_key": "property/5641831400341504/019f1509-4d62-73d8-bed7-c1c80b0d5bf2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hillsboroughcounty.org/en/locations/upper-tampa-bay-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=10513790375460735070&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "upper-tampa-bay-park",
      "poi_latitude": "28.0218514",
      "poi_longitude": "-82.6380471",
      "poi_miles_from_property": "18.7 mi",
      "poi_walking_minutes": "6 hours 54 mins",
      "poi_biking_minutes": "1 hour 42 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 813-855-1765",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad44-742a-9471-71253729fed9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad44-742a-9471-71253729fed9",
        "storage_key": "property/5641831400341504/019f1505-ad44-742a-9471-71253729fed9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJBcecg_zrwogRXghCXKR86JE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_3318f49b73015d265f0bdf8a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Sand Key Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1060 Gulf Blvd, Clearwater, FL 33767, USA",
      "poi_short_description": "Expansive white-sand beach offering plenty of room for picnics, surfing & other outdoor activities.",
      "poi_long_description": "Expansive white-sand beach offering plenty of room for picnics, surfing & other outdoor activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-4325-75ce-8e64-66d07fb2ca34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-4325-75ce-8e64-66d07fb2ca34",
        "storage_key": "property/5641831400341504/019f1509-4325-75ce-8e64-66d07fb2ca34.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "http://www.pinellascounty.org/park/15_sand_key.htm",
      "poi_directions_map_url": "https://maps.google.com/?cid=10332537064523258092&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sand-key-park",
      "poi_latitude": "27.9591133",
      "poi_longitude": "-82.8277083",
      "poi_miles_from_property": "15.2 mi",
      "poi_walking_minutes": "5 hours 37 mins",
      "poi_biking_minutes": "1 hour 19 mins",
      "poi_driving_minutes": "34 mins",
      "poi_business_phone": "+1 727-582-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad44-742a-9471-71253729fed9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad44-742a-9471-71253729fed9",
        "storage_key": "property/5641831400341504/019f1505-ad44-742a-9471-71253729fed9.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJW29wtzH3wogR7Fh3T7eLZI8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_600e63a75f2e7ebd88fd910c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "St. Pete–Clearwater International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "14700 Terminal Blvd #221, Clearwater, FL 33762, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-a05e-72bf-b7e5-47335f397978.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1505-a05e-72bf-b7e5-47335f397978",
        "storage_key": "property/5641831400341504/019f1505-a05e-72bf-b7e5-47335f397978.webp",
        "width": 1000,
        "height": 739
      },
      "poi_business_url": "http://www.fly2pie.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17009677847127533621&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-peteclearwater-international-airport",
      "poi_latitude": "27.9122109",
      "poi_longitude": "-82.6891001",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 727-453-7800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-af98-747c-83c5-37c2d58fc6ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-af98-747c-83c5-37c2d58fc6ad",
        "storage_key": "property/5641831400341504/019f1505-af98-747c-83c5-37c2d58fc6ad.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ499XiXflwogRNSjefeGDDuw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_8abc13eae211a3bdae0f6eeb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Park St Terminal",
      "poi_type": "Transportation & Transit",
      "poi_address": "Clearwater, FL 33756, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-471d-75ed-9fec-d4fdcafc31af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-471d-75ed-9fec-d4fdcafc31af",
        "storage_key": "property/5641831400341504/019f1509-471d-75ed-9fec-d4fdcafc31af.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4808291591592707638&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "park-st-terminal",
      "poi_latitude": "27.964345",
      "poi_longitude": "-82.79916",
      "poi_miles_from_property": "12.2 mi",
      "poi_walking_minutes": "4 hours 33 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-8983-727f-9d28-ded67d054510.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1509-8983-727f-9d28-ded67d054510",
        "storage_key": "property/5641831400341504/019f1509-8983-727f-9d28-ded67d054510.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJUbEhV-fwwogRNoZhJbp7ukI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "ec_d7085ef218f36a2a3a6b8475",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Clearwater Beach Transit Center South",
      "poi_type": "Transportation & Transit",
      "poi_address": "Clearwater, FL 33767, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-4fa6-77dd-9683-3f1450390754.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-4fa6-77dd-9683-3f1450390754",
        "storage_key": "property/5641831400341504/019f1509-4fa6-77dd-9683-3f1450390754.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15144092246934443740&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clearwater-beach-transit-center-south",
      "poi_latitude": "27.977165",
      "poi_longitude": "-82.825169",
      "poi_miles_from_property": "14.0 mi",
      "poi_walking_minutes": "5 hours 11 mins",
      "poi_biking_minutes": "1 hour 20 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-8983-727f-9d28-ded67d054510.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1509-8983-727f-9d28-ded67d054510",
        "storage_key": "property/5641831400341504/019f1509-8983-727f-9d28-ded67d054510.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJRTqBEtT2wogR3FZGaKmfKtI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "ec_3cac5efb1da665960c591ed9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Psta 34th St Layby - Platform - A",
      "poi_type": "Transportation & Transit",
      "poi_address": "Florida 33716, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13009300106520708294&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "psta-34th-st-layby---platform---a",
      "poi_latitude": "27.887544",
      "poi_longitude": "-82.679453",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-8983-727f-9d28-ded67d054510.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1509-8983-727f-9d28-ded67d054510",
        "storage_key": "property/5641831400341504/019f1509-8983-727f-9d28-ded67d054510.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJSyPuQbvlwogRxkSeSYVRirQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "ec_4d0cd1bb50aceae74e78558b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Pinellas Park Transit Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "3801 70th Ave N, Pinellas Park, FL 33781, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.psta.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7721745281634832869&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pinellas-park-transit-station",
      "poi_latitude": "27.8359295",
      "poi_longitude": "-82.68562709999999",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad26-762b-bc5c-832cfc6a7e69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad26-762b-bc5c-832cfc6a7e69",
        "storage_key": "property/5641831400341504/019f1505-ad26-762b-bc5c-832cfc6a7e69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ2bkT3vkwogR5ZHkDWwmKWs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "point_of_interest"
    },
    {
      "id": "ec_6b92d1b23fbb41f767ba9989",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Largo Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Largo, FL 33760, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-4c2e-74cc-ae78-3f24aa69dc03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-4c2e-74cc-ae78-3f24aa69dc03",
        "storage_key": "property/5641831400341504/019f1509-4c2e-74cc-ae78-3f24aa69dc03.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=16279513464193447186&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "largo-transit-center",
      "poi_latitude": "27.912994",
      "poi_longitude": "-82.72684699999999",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad26-762b-bc5c-832cfc6a7e69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad26-762b-bc5c-832cfc6a7e69",
        "storage_key": "property/5641831400341504/019f1505-ad26-762b-bc5c-832cfc6a7e69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc1p_H1HlwogREnVwPT5z7OE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_722880393fc5fc8559812792",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Ulmerton Park N Ride Lot",
      "poi_type": "Transportation & Transit",
      "poi_address": "Largo, FL 33771, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-4cd9-746f-8797-75bee9e7b52d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-4cd9-746f-8797-75bee9e7b52d",
        "storage_key": "property/5641831400341504/019f1509-4cd9-746f-8797-75bee9e7b52d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3114346031729281927&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ulmerton-park-n-ride-lot",
      "poi_latitude": "27.893952",
      "poi_longitude": "-82.76056799999999",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad26-762b-bc5c-832cfc6a7e69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad26-762b-bc5c-832cfc6a7e69",
        "storage_key": "property/5641831400341504/019f1505-ad26-762b-bc5c-832cfc6a7e69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzZ-Xw-v6wogRhwvfIDdhOCs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_fc407a955dac21a431860662",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Amtrak",
      "poi_type": "Transportation & Transit",
      "poi_address": "601 N Nebraska Ave, Tampa, FL 33602, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-58ff-72fb-b6d7-8dc4d8a6ea34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-58ff-72fb-b6d7-8dc4d8a6ea34",
        "storage_key": "property/5641831400341504/019f1509-58ff-72fb-b6d7-8dc4d8a6ea34.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.amtrak.com/stations/tpa",
      "poi_directions_map_url": "https://maps.google.com/?cid=11680206783434409790&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amtrak",
      "poi_latitude": "27.9526866",
      "poi_longitude": "-82.45065249999999",
      "poi_miles_from_property": "26.1 mi",
      "poi_walking_minutes": "9 hours 38 mins",
      "poi_biking_minutes": "1 hour 46 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 833-844-0830",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad26-762b-bc5c-832cfc6a7e69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad26-762b-bc5c-832cfc6a7e69",
        "storage_key": "property/5641831400341504/019f1505-ad26-762b-bc5c-832cfc6a7e69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXWlYhl_EwogRPke3ZS9uGKI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_52d8d7fa95db0641083eb244",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "13577 Feather Sound Dr",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Feather Sound Dr, Clearwater, FL 33762, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=16826908835118841289&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "13577-feather-sound-dr",
      "poi_latitude": "27.8957787",
      "poi_longitude": "-82.66086899999999",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad26-762b-bc5c-832cfc6a7e69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad26-762b-bc5c-832cfc6a7e69",
        "storage_key": "property/5641831400341504/019f1505-ad26-762b-bc5c-832cfc6a7e69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbQUHWOjlwogRyf0jyW4whek",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_d34b2fe8b2b8ea6423d678a2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Morton Plant Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "300 Pinellas St, Clearwater, FL 33756, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-1129-7768-8d1f-62d4c7b81b66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-1129-7768-8d1f-62d4c7b81b66",
        "storage_key": "property/5641831400341504/019f1509-1129-7768-8d1f-62d4c7b81b66.webp",
        "width": 1000,
        "height": 676
      },
      "poi_business_url": "https://baycare.org/hospitals/morton-plant-hospital/patients-and-visitors?utm_campaign=BayCare_DigitalMarketing_M20140288&utm_source=Google&utm_medium=LocalListing&utm_content=Morton_Plant_Hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=3251150992652485143&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "morton-plant-hospital",
      "poi_latitude": "27.9529483",
      "poi_longitude": "-82.8037102",
      "poi_miles_from_property": "11.6 mi",
      "poi_walking_minutes": "4 hours 20 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 727-462-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad09-7236-9fba-9def2adec380.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad09-7236-9fba-9def2adec380",
        "storage_key": "property/5641831400341504/019f1505-ad09-7236-9fba-9def2adec380.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ60HWOMHwwogRF8I1PJpoHi0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_2f87d87314655e6052f87734",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Mease Countryside Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3231 McMullen Booth Rd, Safety Harbor, FL 34695, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-16aa-71bc-9626-34926de95e62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-16aa-71bc-9626-34926de95e62",
        "storage_key": "property/5641831400341504/019f1509-16aa-71bc-9626-34926de95e62.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://baycare.org/hospitals/mease-countryside-hospital/patients-and-visitors?utm_campaign=BayCare_DigitalMarketing_M20140288&utm_source=Google&utm_medium=LocalListing&utm_content=Mease_Countryside_Hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=13889236478498578986&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mease-countryside-hospital",
      "poi_latitude": "28.039268",
      "poi_longitude": "-82.70704289999999",
      "poi_miles_from_property": "14.7 mi",
      "poi_walking_minutes": "5 hours 28 mins",
      "poi_biking_minutes": "1 hour 23 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 727-725-6111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad09-7236-9fba-9def2adec380.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad09-7236-9fba-9def2adec380",
        "storage_key": "property/5641831400341504/019f1505-ad09-7236-9fba-9def2adec380.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJGXlF37jtwogRKiJOJv16wMA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_27aafe3a756fba2734066b13",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "HCA Florida Largo Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "201 14th St SW, Largo, FL 33770, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-5a41-76bf-8cb0-f93cf2f0ec43.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-5a41-76bf-8cb0-f93cf2f0ec43",
        "storage_key": "property/5641831400341504/019f1509-5a41-76bf-8cb0-f93cf2f0ec43.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.hcafloridahealthcare.com/locations/largo-hospital/?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=207753303436979124&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hca-florida-largo-hospital",
      "poi_latitude": "27.9150179",
      "poi_longitude": "-82.8036438",
      "poi_miles_from_property": "9.6 mi",
      "poi_walking_minutes": "3 hours 35 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 727-588-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad09-7236-9fba-9def2adec380.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad09-7236-9fba-9def2adec380",
        "storage_key": "property/5641831400341504/019f1505-ad09-7236-9fba-9def2adec380.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6-idyA36wogRtGtGXIcW4gI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_03e92a6bade113b71c39bd59",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Johns Hopkins All Children's Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "501 6th Ave S, St. Petersburg, FL 33701, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-5de3-7054-9d37-0743cc4c334b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-5de3-7054-9d37-0743cc4c334b",
        "storage_key": "property/5641831400341504/019f1509-5de3-7054-9d37-0743cc4c334b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.hopkinsmedicine.org/all-childrens-hospital/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3434448219884759122&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johns-hopkins-all-childrens-hospital",
      "poi_latitude": "27.764978",
      "poi_longitude": "-82.640609",
      "poi_miles_from_property": "10.4 mi",
      "poi_walking_minutes": "3 hours 57 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 727-898-7451",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad09-7236-9fba-9def2adec380.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad09-7236-9fba-9def2adec380",
        "storage_key": "property/5641831400341504/019f1505-ad09-7236-9fba-9def2adec380.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-2W3BI_hwogRUii0oXWcqS8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_a0ac1ac4182a42fd43d7c18d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "University of South Florida St. Petersburg Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "140 7th Ave S, St. Petersburg, FL 33701, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-6b51-7419-9b60-2dd240c668d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-6b51-7419-9b60-2dd240c668d3",
        "storage_key": "property/5641831400341504/019f1509-6b51-7419-9b60-2dd240c668d3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.stpetersburg.usf.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16956568165064880612&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-south-florida-st-petersburg-campus",
      "poi_latitude": "27.7624407",
      "poi_longitude": "-82.6354867",
      "poi_miles_from_property": "10.7 mi",
      "poi_walking_minutes": "4 hours 2 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 727-873-5179",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad33-763b-a248-ab96ca7d2cd7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad33-763b-a248-ab96ca7d2cd7",
        "storage_key": "property/5641831400341504/019f1505-ad33-763b-a248-ab96ca7d2cd7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ9YozspHhwogR5LFjCOjUUes",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_a847dc38c4cc5320d52f5b63",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Raymond James & Associates",
      "poi_type": "Major Employers & Offices",
      "poi_address": "800 Carillon Pkwy, St. Petersburg, FL 33716, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-6d5b-716c-b544-6a0e87794f9a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-6d5b-716c-b544-6a0e87794f9a",
        "storage_key": "property/5641831400341504/019f1509-6d5b-716c-b544-6a0e87794f9a.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.raymondjames.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3697156673912070147&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "raymond-james--associates",
      "poi_latitude": "27.8903035",
      "poi_longitude": "-82.6718284",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 727-567-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad26-762b-bc5c-832cfc6a7e69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad26-762b-bc5c-832cfc6a7e69",
        "storage_key": "property/5641831400341504/019f1505-ad26-762b-bc5c-832cfc6a7e69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN7FXEL_lwogRA2B-E2jwTjM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "finance"
    },
    {
      "id": "ec_7d82bc8830fc342260ea95f5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Jabil",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10800 Roosevelt Blvd N, St. Petersburg, FL 33716, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-7144-70b2-9c0e-f99269f4e3de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-7144-70b2-9c0e-f99269f4e3de",
        "storage_key": "property/5641831400341504/019f1509-7144-70b2-9c0e-f99269f4e3de.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.jabil.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6369889450975457462&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jabil",
      "poi_latitude": "27.8700471",
      "poi_longitude": "-82.64899849999999",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 727-577-9749",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad26-762b-bc5c-832cfc6a7e69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad26-762b-bc5c-832cfc6a7e69",
        "storage_key": "property/5641831400341504/019f1505-ad26-762b-bc5c-832cfc6a7e69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr3J3E4DmwogRtnDm37RkZlg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "ec_b10be7484ee627c791ca7976",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "BayCare Health System",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2985 Drew St, Clearwater, FL 33759, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-6661-7129-9c9d-d2e1a11be3d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-6661-7129-9c9d-d2e1a11be3d5",
        "storage_key": "property/5641831400341504/019f1509-6661-7129-9c9d-d2e1a11be3d5.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://baycare.org/locations/b/baycare-health-system?utm_campaign=BayCare_DigitalMarketing_M20140288&utm_source=Google&utm_medium=LocalListing&utm_content=BayCare_Health_System",
      "poi_directions_map_url": "https://maps.google.com/?cid=1779506010119243351&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baycare-health-system",
      "poi_latitude": "27.9666199",
      "poi_longitude": "-82.7159145",
      "poi_miles_from_property": "9.3 mi",
      "poi_walking_minutes": "3 hours 27 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 727-820-8200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1505-ad26-762b-bc5c-832cfc6a7e69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1505-ad26-762b-bc5c-832cfc6a7e69",
        "storage_key": "property/5641831400341504/019f1505-ad26-762b-bc5c-832cfc6a7e69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4QDs1TTuwogRV4bUuEkTshg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "ec_354516ffd13d06ab82aed5e7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "poi_name": "Pinellas County Courthouse",
      "poi_type": "Major Employers & Offices",
      "poi_address": "315 Court St #300, Clearwater, FL 33756, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-6b57-746f-900b-385df1d9fdd2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1509-6b57-746f-900b-385df1d9fdd2",
        "storage_key": "property/5641831400341504/019f1509-6b57-746f-900b-385df1d9fdd2.webp",
        "width": 1280,
        "height": 934
      },
      "poi_business_url": "http://www.pinellascounty.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12956387794808060780&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pinellas-county-courthouse",
      "poi_latitude": "27.9618674",
      "poi_longitude": "-82.8012261",
      "poi_miles_from_property": "12.1 mi",
      "poi_walking_minutes": "4 hours 31 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 727-464-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f1509-8a3f-7006-90ae-1f9abffc5877.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1509-8a3f-7006-90ae-1f9abffc5877",
        "storage_key": "property/5641831400341504/019f1509-8a3f-7006-90ae-1f9abffc5877.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH-k9ct3wwogRbLu9sQ1WzrM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_f3f6934b-42f9-4ca7-8507-8b6da506f3b8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_786fdf9a-1325-4eae-86a3-cd52f4efb36a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_a19d70ab-3da1-48ac-bd92-036f92049846",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_48001509-d5af-4c26-8166-f1d9261ba3f8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_b25bce50-da8d-44a6-88d4-d18c0c4eb6fa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_653922d6-c3b0-48da-9bc4-f20f0b1e2ce8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_25aa9e26-4bef-44de-9d58-dc2dbe728b9a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "rating": "5.0",
      "name": "Tai-tai Scherer",
      "text": "This place is wonderful! I had a really bad experience with another apartment and needed a quick turn around and fairways was spectacular ! they helped me so fast and got my process done. Adrianna at the leasing office is the sweetest and so helpful. When I moved in I had a million questions and they were so kind and patient. The maintenance team here is also fantastic and they attend to your request so fast and they are always so nice!",
      "date": "2026-03-09",
      "title": ""
    },
    {
      "id": "custom_cd5e8f7a-0e66-470d-910b-0a101d7e027c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "rating": "5.0",
      "name": "Taylor Jones",
      "text": "I absolutely love living here! The staff is incredibly personable and always goes above and beyond to make residents feel comfortable and valued. Maintenance requests are handled quickly and efficiently, which makes a huge difference in day-to-day living. The community feels very safe, and the neighbors are genuinely friendly, creating a welcoming atmosphere. One of my favorite features is the beautiful pool area - it overlooks peaceful ponds and makes for such a relaxing environment.\n\nOverall, this is a wonderful place to live, and I would highly recommend it to anyone looking for a comfortable and well-managed community!",
      "date": "2026-04-28",
      "title": ""
    },
    {
      "id": "custom_cfc0f6cb-1000-45de-bbfc-2eab720715c5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "rating": "5.0",
      "name": "Emily Reyes",
      "text": "I can’t say enough great things about living at Fairways at Feather Sound! My boyfriend and I just renewed our lease for a second year. From day one, the experience living here has been nothing but positive. The maintenance team is absolutely excellent! All 3 of the guys are super friendly, knowledgeable, and professional. Every time I’ve needed something they’ve come the same day. The community is always clean and well maintained. The gym, pool, tennis court, and clubhouse are spotless every time I use them. Adriana and Kayla are truly amazing! They are both super friendly, reliable, attentive, and knowledgeable. They truly care and make the effort to get to know you. I do think that the price is great for the value you get here. The community hosts monthly events and food trucks which creates such a fun and welcoming environment. The entire community is safe, welcoming, and peaceful. I would highly recommend this apartment complex to anyone looking for a great place to call home!",
      "date": "2026-03-20",
      "title": ""
    },
    {
      "id": "custom_1c2dcaae-ccdb-4b70-bc63-f8479ca70524",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "rating": "4.0",
      "name": "Reggie Spigner",
      "text": "Ok... Here's my take. I've been a tenant since March of '25 (9 mos). I would give the place a 8 out of 10 so far. It's nice. Everything in our unit works fine, the maintenance team on my side is great! The office team is cool and most of the people in the neighborhood are nice too. Good, safe neighborhood for walking. The outdoors are very well lit at night (My Wife feels very safe coming home by herself)  And the pond out back is nice! The best thing about it is the LOCATION. It's in the middle of everything. The only downside for me is... Our rent is a bit high for the size of our unit. Other than that, I believe we'll be here for a while 👍🏾 PS.. I will update this review in a few months from now.",
      "date": "2025-12-29",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_15704b68efd67ff33c1ff22b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f14c4-302f-70eb-bf7d-19265ceee73b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-302f-70eb-bf7d-19265ceee73b",
        "storage_key": "property/5641831400341504/019f14c4-302f-70eb-bf7d-19265ceee73b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1 BR, 1BA - 776 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=kfwti5VJxfk"
    },
    {
      "id": "ec_eb8e7cdd0c1e839e271865f4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f14c4-3111-75ff-8f95-c2325115cae4.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-3111-75ff-8f95-c2325115cae4",
        "storage_key": "property/5641831400341504/019f14c4-3111-75ff-8f95-c2325115cae4.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "Fairways at Feather Sound - Community Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/VbZfaALAU9k"
    },
    {
      "id": "ec_935ef149ca0171145eddbcd2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f14c4-3280-7419-97d9-9f7ca00f0c5a.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-3280-7419-97d9-9f7ca00f0c5a",
        "storage_key": "property/5641831400341504/019f14c4-3280-7419-97d9-9f7ca00f0c5a.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=FdVy6aMBSgw"
    },
    {
      "id": "ec_e06703813e435dd1a8596d86",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f14c4-3b8b-765e-9030-0b898932fdbf.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-3b8b-765e-9030-0b898932fdbf",
        "storage_key": "property/5641831400341504/019f14c4-3b8b-765e-9030-0b898932fdbf.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Business Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=q8FmsksqjPD"
    },
    {
      "id": "ec_b6dbac530f2db6d0f1e1b91d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f14c4-3b62-7198-a39a-ac9b74f37c91.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c4-3b62-7198-a39a-ac9b74f37c91",
        "storage_key": "property/5641831400341504/019f14c4-3b62-7198-a39a-ac9b74f37c91.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Leasing Office / Clubhouse",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=USP8ymz8eF4"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa45-84da-73b4-9a7e-2ec2d8ec8920",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "fairways-at-feather-sound",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504"
    },
    {
      "lead_collector_id": "0198aa45-853e-7394-921e-f05e487a8b2b",
      "lead_source": "FACEBOOK_ADS",
      "name": "fairways-at-feather-sound",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504"
    },
    {
      "lead_collector_id": "0198aa45-85a0-74bf-baf4-f3c2a245fbc9",
      "lead_source": "LANDING_PAGE",
      "name": "fairways-at-feather-sound",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "custom",
      "page_item_url": "discover-one-bedroom-apartments-for-rent-clearwater-fl",
      "search_query": "One Bedroom Apartments For Rent In Clearwater FL",
      "category": "Floorplan",
      "h1_title": "Discover One Bedroom Apartments For Rent In Clearwater FL",
      "h2_subtitle": "Fairways at Feather Sound offers modern one bedroom apartments with stunning amenities. Enjoy a vibrant community with easy access to Clearwater's best attractions.",
      "page_copy": "At Fairways at Feather Sound, our one bedroom apartments for rent in Clearwater FL are designed to provide you with a comfortable and stylish living experience. Each apartment features a sleek kitchen, in-home washer and dryer, and spacious walk-in closets. Our community is nestled around two private lakes, offering a serene environment with tropical gardens and meandering trails. Residents can enjoy a heated pool, a newly upgraded fitness facility, and convenient access to I-275, making it easy to explore the vibrant Clearwater area. Whether you're relaxing at home or exploring the nearby Feather Sound Country Club, our community offers the laid-back Florida lifestyle you've been searching for.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f6c0e-e1b6-77c5-be1c-a793e82d779b.webp",
      "featured_image_media": {
        "alt_text": "Living room with a grey sofa, modern floor lamp, coffee table, and dining area.",
        "public_id": "019f6c0e-e1b6-77c5-be1c-a793e82d779b",
        "storage_key": "property/5641831400341504/019f6c0e-e1b6-77c5-be1c-a793e82d779b.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f6c0e-ebc4-722e-84c8-7262a774ec77.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of the apartment building with landscaping",
        "public_id": "019f6c0e-ebc4-722e-84c8-7262a774ec77",
        "storage_key": "property/5641831400341504/019f6c0e-ebc4-722e-84c8-7262a774ec77.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Fairways at Feather Sound | One Bedroom Apartments For Rent In Clearwater FL",
      "seo_description": "Explore Fairways at Feather Sound's one bedroom apartments for rent in Clearwater FL. Enjoy modern amenities and a prime location near Feather Sound Country Club.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "custom",
      "page_item_url": "spacious-two-bedrooms-apartments-for-rent-clearwater-fl",
      "search_query": "Two Bedrooms Apartments For Rent In Clearwater FL",
      "category": "Floorplan",
      "h1_title": "Spacious Two Bedrooms Apartments For Rent In Clearwater FL",
      "h2_subtitle": "Fairways at Feather Sound offers luxurious two bedroom apartments with exceptional amenities. Experience a vibrant community in the heart of Clearwater.",
      "page_copy": "Fairways at Feather Sound presents two bedrooms apartments for rent in Clearwater FL, perfect for those seeking comfort and style. Each apartment features a modern kitchen, in-home washer and dryer, and generous walk-in closets. Our community is beautifully designed around two private lakes, providing a peaceful setting with tropical gardens and scenic trails. Residents can enjoy a heated pool, a state-of-the-art fitness center, and easy access to I-275, making it convenient to explore Clearwater's attractions. Whether you're enjoying the tranquility of home or the nearby Feather Sound Country Club, our community embodies the relaxed Florida lifestyle you desire.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f6c0e-e1b6-77c5-be1c-a793e82d779b.webp",
      "featured_image_media": {
        "alt_text": "Living room with a grey sofa, modern floor lamp, coffee table, and dining area.",
        "public_id": "019f6c0e-e1b6-77c5-be1c-a793e82d779b",
        "storage_key": "property/5641831400341504/019f6c0e-e1b6-77c5-be1c-a793e82d779b.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f6c0e-ebc4-722e-84c8-7262a774ec77.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of the apartment building with landscaping",
        "public_id": "019f6c0e-ebc4-722e-84c8-7262a774ec77",
        "storage_key": "property/5641831400341504/019f6c0e-ebc4-722e-84c8-7262a774ec77.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Fairways at Feather Sound | Two Bedrooms Apartments For Rent In Clearwater FL",
      "seo_description": "Discover Fairways at Feather Sound's two bedrooms apartments for rent in Clearwater FL. Enjoy luxurious amenities and a prime location near Feather Sound Country Club.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-near-me-with-pool",
      "search_query": "Apartments For Rent Near Me with Pool",
      "category": "Amenity",
      "h1_title": "Find Apartments For Rent Near Me with Pool in Clearwater",
      "h2_subtitle": "Fairways at Feather Sound offers stunning apartments with a heated pool and top-notch amenities. Enjoy a vibrant community in a prime Clearwater location.",
      "page_copy": "Discover the perfect apartments for rent near me with pool at Fairways at Feather Sound. Our community features a heated pool, ideal for relaxation and leisure. Enjoy the convenience of a modern fitness center, a dog park, and scenic walking trails. Each apartment is designed with a sleek kitchen, in-home washer and dryer, and spacious layouts. Located just off I-275, our community offers easy access to Clearwater's attractions, including Feather Sound Country Club. Whether you're lounging by the pool or exploring nearby shops and restaurants, Fairways at Feather Sound provides the ideal Florida lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f6c0e-e1b6-77c5-be1c-a793e82d779b.webp",
      "featured_image_media": {
        "alt_text": "Living room with a grey sofa, modern floor lamp, coffee table, and dining area.",
        "public_id": "019f6c0e-e1b6-77c5-be1c-a793e82d779b",
        "storage_key": "property/5641831400341504/019f6c0e-e1b6-77c5-be1c-a793e82d779b.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f6c0e-ebc4-722e-84c8-7262a774ec77.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of the apartment building with landscaping",
        "public_id": "019f6c0e-ebc4-722e-84c8-7262a774ec77",
        "storage_key": "property/5641831400341504/019f6c0e-ebc4-722e-84c8-7262a774ec77.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Fairways at Feather Sound | Apartments For Rent Near Me with Pool",
      "seo_description": "Explore Fairways at Feather Sound's apartments for rent near me with pool. Enjoy luxurious amenities and a prime Clearwater location near Feather Sound Country Club.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "custom",
      "page_item_url": "explore-apartments-for-rent-near-me-with-fitness-center",
      "search_query": "Apartments For Rent Near Me with Fitness Center",
      "category": "Amenity",
      "h1_title": "Explore Apartments For Rent Near Me with Fitness Center in Clearwater",
      "h2_subtitle": "Fairways at Feather Sound offers modern apartments with a state-of-the-art fitness center. Enjoy a vibrant community with exceptional amenities in Clearwater.",
      "page_copy": "Discover the ideal apartments for rent near me with fitness center at Fairways at Feather Sound. Our community features a newly upgraded fitness facility, perfect for maintaining an active lifestyle. Enjoy additional amenities such as a heated pool, dog park, and scenic walking trails. Each apartment is designed with a modern kitchen, in-home washer and dryer, and spacious layouts. Conveniently located off I-275, our community provides easy access to Clearwater's attractions, including Feather Sound Country Club. Whether you're working out in the fitness center or exploring nearby shops and restaurants, Fairways at Feather Sound offers the perfect Florida lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f6c0e-e1b6-77c5-be1c-a793e82d779b.webp",
      "featured_image_media": {
        "alt_text": "Living room with a grey sofa, modern floor lamp, coffee table, and dining area.",
        "public_id": "019f6c0e-e1b6-77c5-be1c-a793e82d779b",
        "storage_key": "property/5641831400341504/019f6c0e-e1b6-77c5-be1c-a793e82d779b.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f6c0e-ebc4-722e-84c8-7262a774ec77.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of the apartment building with landscaping",
        "public_id": "019f6c0e-ebc4-722e-84c8-7262a774ec77",
        "storage_key": "property/5641831400341504/019f6c0e-ebc4-722e-84c8-7262a774ec77.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Fairways at Feather Sound | Apartments For Rent Near Me with Fitness Center",
      "seo_description": "Discover Fairways at Feather Sound's apartments for rent near me with fitness center. Enjoy luxurious amenities and a prime Clearwater location near Feather Sound Country Club.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-me-with-lounge",
      "search_query": "Apartments For Rent Near Me with Lounge",
      "category": "Amenity",
      "h1_title": "Discover Apartments For Rent Near Me with Lounge in Clearwater",
      "h2_subtitle": "Fairways at Feather Sound offers stylish apartments with a relaxing lounge. Enjoy a vibrant community with exceptional amenities in Clearwater.",
      "page_copy": "Find your perfect home at Fairways at Feather Sound, offering apartments for rent near me with lounge. Our community features a comfortable lounge area, ideal for socializing and relaxation. Enjoy additional amenities such as a heated pool, fitness center, and scenic walking trails. Each apartment is designed with a modern kitchen, in-home washer and dryer, and spacious layouts. Conveniently located off I-275, our community provides easy access to Clearwater's attractions, including Feather Sound Country Club. Whether you're unwinding in the lounge or exploring nearby shops and restaurants, Fairways at Feather Sound offers the perfect Florida lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f6c0e-e1b6-77c5-be1c-a793e82d779b.webp",
      "featured_image_media": {
        "alt_text": "Living room with a grey sofa, modern floor lamp, coffee table, and dining area.",
        "public_id": "019f6c0e-e1b6-77c5-be1c-a793e82d779b",
        "storage_key": "property/5641831400341504/019f6c0e-e1b6-77c5-be1c-a793e82d779b.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f6c0e-ebc4-722e-84c8-7262a774ec77.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of the apartment building with landscaping",
        "public_id": "019f6c0e-ebc4-722e-84c8-7262a774ec77",
        "storage_key": "property/5641831400341504/019f6c0e-ebc4-722e-84c8-7262a774ec77.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Fairways at Feather Sound | Apartments For Rent Near Me with Lounge",
      "seo_description": "Explore Fairways at Feather Sound's apartments for rent near me with lounge. Enjoy luxurious amenities and a prime Clearwater location near Feather Sound Country Club.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-near-me-with-dog-park",
      "search_query": "Apartments For Rent Near Me with Dog Park",
      "category": "Amenity",
      "h1_title": "Find Apartments For Rent Near Me with Dog Park in Clearwater",
      "h2_subtitle": "Fairways at Feather Sound offers pet-friendly apartments with a dedicated dog park. Enjoy a vibrant community with exceptional amenities in Clearwater.",
      "page_copy": "Discover the ideal apartments for rent near me with dog park at Fairways at Feather Sound. Our community features a dedicated dog park, perfect for your furry friends to play and socialize. Enjoy additional amenities such as a heated pool, fitness center, and scenic walking trails. Each apartment is designed with a modern kitchen, in-home washer and dryer, and spacious layouts. Conveniently located off I-275, our community provides easy access to Clearwater's attractions, including Feather Sound Country Club. Whether you're enjoying the dog park or exploring nearby shops and restaurants, Fairways at Feather Sound offers the perfect Florida lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f6c0e-e1b6-77c5-be1c-a793e82d779b.webp",
      "featured_image_media": {
        "alt_text": "Living room with a grey sofa, modern floor lamp, coffee table, and dining area.",
        "public_id": "019f6c0e-e1b6-77c5-be1c-a793e82d779b",
        "storage_key": "property/5641831400341504/019f6c0e-e1b6-77c5-be1c-a793e82d779b.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f6c0e-ebc4-722e-84c8-7262a774ec77.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of the apartment building with landscaping",
        "public_id": "019f6c0e-ebc4-722e-84c8-7262a774ec77",
        "storage_key": "property/5641831400341504/019f6c0e-ebc4-722e-84c8-7262a774ec77.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Fairways at Feather Sound | Apartments For Rent Near Me with Dog Park",
      "seo_description": "Explore Fairways at Feather Sound's apartments for rent near me with dog park. Enjoy luxurious amenities and a prime Clearwater location near Feather Sound Country Club.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "custom",
      "page_item_url": "explore-apartments-for-rent-near-walk-up-clearwater",
      "search_query": "Apartments For Rent Near Me with Walk-Up",
      "category": "Amenity",
      "h1_title": "Explore Apartments For Rent Near Me with Walk-Up in Clearwater",
      "h2_subtitle": "Fairways at Feather Sound offers convenient walk-up apartments with modern amenities. Enjoy a vibrant community in a prime Clearwater location.",
      "page_copy": "Discover the perfect apartments for rent near me with walk-up access at Fairways at Feather Sound. Our community features convenient walk-up apartments, providing easy access to your home. Enjoy additional amenities such as a heated pool, fitness center, and scenic walking trails. Each apartment is designed with a modern kitchen, in-home washer and dryer, and spacious layouts. Conveniently located off I-275, our community provides easy access to Clearwater's attractions, including Feather Sound Country Club. Whether you're enjoying the walk-up convenience or exploring nearby shops and restaurants, Fairways at Feather Sound offers the perfect Florida lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f6c0e-e1b6-77c5-be1c-a793e82d779b.webp",
      "featured_image_media": {
        "alt_text": "Living room with a grey sofa, modern floor lamp, coffee table, and dining area.",
        "public_id": "019f6c0e-e1b6-77c5-be1c-a793e82d779b",
        "storage_key": "property/5641831400341504/019f6c0e-e1b6-77c5-be1c-a793e82d779b.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f6c0e-ebc4-722e-84c8-7262a774ec77.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of the apartment building with landscaping",
        "public_id": "019f6c0e-ebc4-722e-84c8-7262a774ec77",
        "storage_key": "property/5641831400341504/019f6c0e-ebc4-722e-84c8-7262a774ec77.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Fairways at Feather Sound | Apartments For Rent Near Me with Walk-Up",
      "seo_description": "Discover Fairways at Feather Sound's apartments for rent near me with walk-up. Enjoy luxurious amenities and a prime Clearwater location near Feather Sound Country Club.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-me-with-kitchen",
      "search_query": "Apartments For Rent Near Me with Kitchen",
      "category": "Amenity",
      "h1_title": "Discover Apartments For Rent Near Me with Kitchen in Clearwater",
      "h2_subtitle": "Fairways at Feather Sound offers modern apartments with sleek kitchens. Enjoy a vibrant community with exceptional amenities in Clearwater.",
      "page_copy": "Explore the ideal apartments for rent near me with kitchen at Fairways at Feather Sound. Our community features apartments with modern kitchens, equipped with high-end appliances like a dishwasher, microwave, and refrigerator. Enjoy additional amenities such as a heated pool, fitness center, and scenic walking trails. Each apartment is designed with spacious layouts and in-home washer and dryer. Conveniently located off I-275, our community provides easy access to Clearwater's attractions, including Feather Sound Country Club. Whether you're cooking in your stylish kitchen or exploring nearby shops and restaurants, Fairways at Feather Sound offers the perfect Florida lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f6c0e-e1b6-77c5-be1c-a793e82d779b.webp",
      "featured_image_media": {
        "alt_text": "Living room with a grey sofa, modern floor lamp, coffee table, and dining area.",
        "public_id": "019f6c0e-e1b6-77c5-be1c-a793e82d779b",
        "storage_key": "property/5641831400341504/019f6c0e-e1b6-77c5-be1c-a793e82d779b.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f6c0e-ebc4-722e-84c8-7262a774ec77.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of the apartment building with landscaping",
        "public_id": "019f6c0e-ebc4-722e-84c8-7262a774ec77",
        "storage_key": "property/5641831400341504/019f6c0e-ebc4-722e-84c8-7262a774ec77.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Fairways at Feather Sound | Apartments For Rent Near Me with Kitchen",
      "seo_description": "Explore Fairways at Feather Sound's apartments for rent near me with kitchen. Enjoy luxurious amenities and a prime Clearwater location near Feather Sound Country Club.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-near-me-walk-in-closets",
      "search_query": "Apartments For Rent Near Me with Walk-In Closets",
      "category": "Amenity",
      "h1_title": "Find Apartments For Rent Near Me with Walk-In Closets in Clearwater",
      "h2_subtitle": "Fairways at Feather Sound offers spacious apartments with walk-in closets. Enjoy a vibrant community with exceptional amenities in Clearwater.",
      "page_copy": "Discover the perfect apartments for rent near me with walk-in closets at Fairways at Feather Sound. Our community features apartments with generous walk-in closets, providing ample storage space for your belongings. Enjoy additional amenities such as a heated pool, fitness center, and scenic walking trails. Each apartment is designed with a modern kitchen, in-home washer and dryer, and spacious layouts. Conveniently located off I-275, our community provides easy access to Clearwater's attractions, including Feather Sound Country Club. Whether you're organizing in your walk-in closet or exploring nearby shops and restaurants, Fairways at Feather Sound offers the perfect Florida lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f6c0e-e1b6-77c5-be1c-a793e82d779b.webp",
      "featured_image_media": {
        "alt_text": "Living room with a grey sofa, modern floor lamp, coffee table, and dining area.",
        "public_id": "019f6c0e-e1b6-77c5-be1c-a793e82d779b",
        "storage_key": "property/5641831400341504/019f6c0e-e1b6-77c5-be1c-a793e82d779b.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f6c0e-ebc4-722e-84c8-7262a774ec77.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of the apartment building with landscaping",
        "public_id": "019f6c0e-ebc4-722e-84c8-7262a774ec77",
        "storage_key": "property/5641831400341504/019f6c0e-ebc4-722e-84c8-7262a774ec77.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Fairways at Feather Sound | Apartments For Rent Near Me with Walk-In Closets",
      "seo_description": "Explore Fairways at Feather Sound's apartments for rent near me with walk-in closets. Enjoy luxurious amenities and a prime Clearwater location near Feather Sound Country Club.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-me-washer-dryer-clearwater",
      "search_query": "Apartments For Rent Near Me with Washer/Dryer",
      "category": "Amenity",
      "h1_title": "Discover Apartments For Rent Near Me with Washer/Dryer in Clearwater",
      "h2_subtitle": "Fairways at Feather Sound offers modern apartments with in-home washer/dryer. Enjoy a vibrant community with exceptional amenities in Clearwater.",
      "page_copy": "Explore the ideal apartments for rent near me with washer/dryer at Fairways at Feather Sound. Our community features apartments equipped with in-home washer and dryer, making laundry day a breeze. Enjoy additional amenities such as a heated pool, fitness center, and scenic walking trails. Each apartment is designed with a modern kitchen, spacious layouts, and walk-in closets. Conveniently located off I-275, our community provides easy access to Clearwater's attractions, including Feather Sound Country Club. Whether you're doing laundry in the comfort of your home or exploring nearby shops and restaurants, Fairways at Feather Sound offers the perfect Florida lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f6c0e-e1b6-77c5-be1c-a793e82d779b.webp",
      "featured_image_media": {
        "alt_text": "Living room with a grey sofa, modern floor lamp, coffee table, and dining area.",
        "public_id": "019f6c0e-e1b6-77c5-be1c-a793e82d779b",
        "storage_key": "property/5641831400341504/019f6c0e-e1b6-77c5-be1c-a793e82d779b.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f6c0e-ebc4-722e-84c8-7262a774ec77.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of the apartment building with landscaping",
        "public_id": "019f6c0e-ebc4-722e-84c8-7262a774ec77",
        "storage_key": "property/5641831400341504/019f6c0e-ebc4-722e-84c8-7262a774ec77.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Fairways at Feather Sound | Apartments For Rent Near Me with Washer/Dryer",
      "seo_description": "Explore Fairways at Feather Sound's apartments for rent near me with washer/dryer. Enjoy luxurious amenities and a prime Clearwater location near Feather Sound Country Club.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-clearwater-fl-near-hca-hospital",
      "search_query": "Apartments For Rent In Clearwater FL Near HCA Florida St. Petersburg Hospital",
      "category": "POI",
      "h1_title": "Find Apartments For Rent In Clearwater FL Near HCA Florida St. Petersburg Hospital",
      "h2_subtitle": "Fairways at Feather Sound offers modern apartments conveniently located near HCA Florida St. Petersburg Hospital. Enjoy a vibrant community with exceptional amenities.",
      "page_copy": "Discover the perfect apartments for rent in Clearwater FL near HCA Florida St. Petersburg Hospital at Fairways at Feather Sound. Our community features spacious one and two bedroom apartments with modern finishes, including a sleek kitchen, in-home washer and dryer, and walk-in closets. Enjoy community amenities such as a heated pool, fitness center, and scenic walking trails. Conveniently located off I-275, our community provides easy access to Clearwater's attractions and is a short drive from HCA Florida St. Petersburg Hospital, offering comprehensive healthcare services. Whether you're relaxing at home or exploring nearby shops and restaurants, Fairways at Feather Sound offers the perfect Florida lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f6c0e-e1b6-77c5-be1c-a793e82d779b.webp",
      "featured_image_media": {
        "alt_text": "Living room with a grey sofa, modern floor lamp, coffee table, and dining area.",
        "public_id": "019f6c0e-e1b6-77c5-be1c-a793e82d779b",
        "storage_key": "property/5641831400341504/019f6c0e-e1b6-77c5-be1c-a793e82d779b.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f6c0e-ebc4-722e-84c8-7262a774ec77.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of the apartment building with landscaping",
        "public_id": "019f6c0e-ebc4-722e-84c8-7262a774ec77",
        "storage_key": "property/5641831400341504/019f6c0e-ebc4-722e-84c8-7262a774ec77.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Fairways at Feather Sound | Apartments For Rent In Clearwater FL Near HCA Florida St. Petersburg Hospital",
      "seo_description": "Explore Fairways at Feather Sound's apartments for rent in Clearwater FL near HCA Florida St. Petersburg Hospital. Enjoy luxurious amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-in-clearwater-fl-near-eckerd-college",
      "search_query": "Apartments For Rent In Clearwater FL Near Eckerd College",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Clearwater FL Near Eckerd College",
      "h2_subtitle": "Fairways at Feather Sound offers modern apartments conveniently located near Eckerd College. Enjoy a vibrant community with exceptional amenities.",
      "page_copy": "Explore the ideal apartments for rent in Clearwater FL near Eckerd College at Fairways at Feather Sound. Our community features spacious one and two bedroom apartments with modern finishes, including a sleek kitchen, in-home washer and dryer, and walk-in closets. Enjoy community amenities such as a heated pool, fitness center, and scenic walking trails. Conveniently located off I-275, our community provides easy access to Clearwater's attractions and is a short drive from Eckerd College, making it ideal for students and faculty. Whether you're relaxing at home or exploring nearby shops and restaurants, Fairways at Feather Sound offers the perfect Florida lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f6c0e-e1b6-77c5-be1c-a793e82d779b.webp",
      "featured_image_media": {
        "alt_text": "Living room with a grey sofa, modern floor lamp, coffee table, and dining area.",
        "public_id": "019f6c0e-e1b6-77c5-be1c-a793e82d779b",
        "storage_key": "property/5641831400341504/019f6c0e-e1b6-77c5-be1c-a793e82d779b.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f6c0e-ebc4-722e-84c8-7262a774ec77.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of the apartment building with landscaping",
        "public_id": "019f6c0e-ebc4-722e-84c8-7262a774ec77",
        "storage_key": "property/5641831400341504/019f6c0e-ebc4-722e-84c8-7262a774ec77.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Fairways at Feather Sound | Apartments For Rent In Clearwater FL Near Eckerd College",
      "seo_description": "Explore Fairways at Feather Sound's apartments for rent in Clearwater FL near Eckerd College. Enjoy luxurious amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "custom",
      "page_item_url": "explore-apartments-rent-clearwater-fl-near-usf-st-pete",
      "search_query": "Apartments For Rent In Clearwater FL Near University of South Florida St. Petersburg Campus",
      "category": "POI",
      "h1_title": "Explore Apartments For Rent In Clearwater FL Near University of South Florida St. Petersburg Campus",
      "h2_subtitle": "Fairways at Feather Sound offers modern apartments conveniently located near USF St. Petersburg Campus. Enjoy a vibrant community with exceptional amenities.",
      "page_copy": "Discover the ideal apartments for rent in Clearwater FL near University of South Florida St. Petersburg Campus at Fairways at Feather Sound. Our community features spacious one and two bedroom apartments with modern finishes, including a sleek kitchen, in-home washer and dryer, and walk-in closets. Enjoy community amenities such as a heated pool, fitness center, and scenic walking trails. Conveniently located off I-275, our community provides easy access to Clearwater's attractions and is a short drive from USF St. Petersburg Campus, making it ideal for students and faculty. Whether you're relaxing at home or exploring nearby shops and restaurants, Fairways at Feather Sound offers the perfect Florida lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f6c0e-e1b6-77c5-be1c-a793e82d779b.webp",
      "featured_image_media": {
        "alt_text": "Living room with a grey sofa, modern floor lamp, coffee table, and dining area.",
        "public_id": "019f6c0e-e1b6-77c5-be1c-a793e82d779b",
        "storage_key": "property/5641831400341504/019f6c0e-e1b6-77c5-be1c-a793e82d779b.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f6c0e-ebc4-722e-84c8-7262a774ec77.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of the apartment building with landscaping",
        "public_id": "019f6c0e-ebc4-722e-84c8-7262a774ec77",
        "storage_key": "property/5641831400341504/019f6c0e-ebc4-722e-84c8-7262a774ec77.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Fairways at Feather Sound | Apartments For Rent In Clearwater FL Near University of South Florida St. Petersburg Campus",
      "seo_description": "Explore Fairways at Feather Sound's apartments for rent in Clearwater FL near USF St. Petersburg Campus. Enjoy luxurious amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-in-clearwater-fl-near-university-tampa",
      "search_query": "Apartments For Rent In Clearwater FL Near The University of Tampa",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Clearwater FL Near The University of Tampa",
      "h2_subtitle": "Fairways at Feather Sound offers modern apartments conveniently located near The University of Tampa. Enjoy a vibrant community with exceptional amenities.",
      "page_copy": "Explore the ideal apartments for rent in Clearwater FL near The University of Tampa at Fairways at Feather Sound. Our community features spacious one and two bedroom apartments with modern finishes, including a sleek kitchen, in-home washer and dryer, and walk-in closets. Enjoy community amenities such as a heated pool, fitness center, and scenic walking trails. Conveniently located off I-275, our community provides easy access to Clearwater's attractions and is a short drive from The University of Tampa, making it ideal for students and faculty. Whether you're relaxing at home or exploring nearby shops and restaurants, Fairways at Feather Sound offers the perfect Florida lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f6c0e-e1b6-77c5-be1c-a793e82d779b.webp",
      "featured_image_media": {
        "alt_text": "Living room with a grey sofa, modern floor lamp, coffee table, and dining area.",
        "public_id": "019f6c0e-e1b6-77c5-be1c-a793e82d779b",
        "storage_key": "property/5641831400341504/019f6c0e-e1b6-77c5-be1c-a793e82d779b.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f6c0e-ebc4-722e-84c8-7262a774ec77.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of the apartment building with landscaping",
        "public_id": "019f6c0e-ebc4-722e-84c8-7262a774ec77",
        "storage_key": "property/5641831400341504/019f6c0e-ebc4-722e-84c8-7262a774ec77.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Fairways at Feather Sound | Apartments For Rent In Clearwater FL Near The University of Tampa",
      "seo_description": "Explore Fairways at Feather Sound's apartments for rent in Clearwater FL near The University of Tampa. Enjoy luxurious amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "custom",
      "page_item_url": "explore-two-bedrooms-apartments-for-rent-clearwater-fl",
      "search_query": "Two Bedrooms Apartments For Rent In Clearwater FL",
      "category": "Floorplan",
      "h1_title": "Explore Two Bedrooms Apartments For Rent In Clearwater FL",
      "h2_subtitle": "Fairways at Feather Sound offers spacious two bedroom apartments with modern amenities. Enjoy a vibrant community with beautiful surroundings and convenient access.",
      "page_copy": "Discover the perfect two bedrooms apartments for rent in Clearwater FL at Fairways at Feather Sound. Our apartments feature spacious layouts and beautiful finishes, including a modern kitchen and in-home washer and dryer, designed to enhance your living experience. The community is nestled around two private lakes with tropical gardens and meandering trails, providing a serene environment for relaxation and leisure. \n\nLocated just off I-275, our pet-friendly community offers easy access to Feather Sound Country Club, local dining, and shopping options. Residents can enjoy a heated pool and a newly upgraded fitness facility, making it easy to maintain an active lifestyle. Experience the laid-back Florida lifestyle at Fairways at Feather Sound, where your ideal two bedroom apartment awaits.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f6c0e-e1b6-77c5-be1c-a793e82d779b.webp",
      "featured_image_media": {
        "alt_text": "Living room with a grey sofa, modern floor lamp, coffee table, and dining area.",
        "public_id": "019f6c0e-e1b6-77c5-be1c-a793e82d779b",
        "storage_key": "property/5641831400341504/019f6c0e-e1b6-77c5-be1c-a793e82d779b.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f6c0e-ebc4-722e-84c8-7262a774ec77.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of the apartment building with landscaping",
        "public_id": "019f6c0e-ebc4-722e-84c8-7262a774ec77",
        "storage_key": "property/5641831400341504/019f6c0e-ebc4-722e-84c8-7262a774ec77.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Fairways at Feather Sound | Two Bedrooms Apartments For Rent In Clearwater FL",
      "seo_description": "Find two bedrooms apartments for rent in Clearwater FL at Fairways at Feather Sound. Enjoy modern living with great amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-me-fitness-center",
      "search_query": "Apartments For Rent Near Me with Fitness Center",
      "category": "Amenity",
      "h1_title": "Discover Apartments For Rent Near Me with Fitness Center",
      "h2_subtitle": "Fairways at Feather Sound offers modern apartments with a state-of-the-art fitness center. Enjoy a vibrant community with beautiful surroundings and convenient access.",
      "page_copy": "Explore the perfect apartments for rent near me with fitness center at Fairways at Feather Sound in Clearwater. Our community features a newly upgraded fitness center, ideal for maintaining an active lifestyle, along with a heated pool for relaxation. The spacious one and two bedroom apartments include modern kitchens and in-home washers and dryers, providing a comfortable and convenient living experience. \n\nSurrounded by two private lakes, tropical gardens, and meandering trails, our pet-friendly community offers a serene environment for all residents. Conveniently located just off I-275, Fairways at Feather Sound provides easy access to Feather Sound Country Club, local dining, and shopping options. Experience the laid-back Florida lifestyle with our exceptional amenities, including a dog park, tennis court, and sundeck, making it the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f6c0e-e1b6-77c5-be1c-a793e82d779b.webp",
      "featured_image_media": {
        "alt_text": "Living room with a grey sofa, modern floor lamp, coffee table, and dining area.",
        "public_id": "019f6c0e-e1b6-77c5-be1c-a793e82d779b",
        "storage_key": "property/5641831400341504/019f6c0e-e1b6-77c5-be1c-a793e82d779b.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f6c0e-ebc4-722e-84c8-7262a774ec77.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of the apartment building with landscaping",
        "public_id": "019f6c0e-ebc4-722e-84c8-7262a774ec77",
        "storage_key": "property/5641831400341504/019f6c0e-ebc4-722e-84c8-7262a774ec77.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Fairways at Feather Sound | Apartments For Rent Near Me with Fitness Center",
      "seo_description": "Find apartments for rent near me with fitness center at Fairways at Feather Sound. Enjoy modern amenities, beautiful surroundings, and a prime Clearwater location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-me-with-dog-park",
      "search_query": "Apartments For Rent Near Me with Dog Park",
      "category": "Amenity",
      "h1_title": "Discover Apartments For Rent Near Me with Dog Park",
      "h2_subtitle": "Fairways at Feather Sound offers pet-friendly apartments with a dedicated dog park. Enjoy a vibrant community with beautiful surroundings and convenient access.",
      "page_copy": "Explore the perfect apartments for rent near me with dog park at Fairways at Feather Sound in Clearwater. Our community features a dedicated dog park, ideal for pet owners seeking a welcoming environment for their furry friends. The spacious one and two bedroom apartments include modern kitchens and in-home washers and dryers, providing a comfortable and convenient living experience. \n\nSurrounded by two private lakes, tropical gardens, and meandering trails, our pet-friendly community offers a serene environment for all residents. Conveniently located just off I-275, Fairways at Feather Sound provides easy access to Feather Sound Country Club, local dining, and shopping options. Experience the laid-back Florida lifestyle with our exceptional amenities, including a heated pool, fitness center, and sundeck, making it the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f6c0e-e1b6-77c5-be1c-a793e82d779b.webp",
      "featured_image_media": {
        "alt_text": "Living room with a grey sofa, modern floor lamp, coffee table, and dining area.",
        "public_id": "019f6c0e-e1b6-77c5-be1c-a793e82d779b",
        "storage_key": "property/5641831400341504/019f6c0e-e1b6-77c5-be1c-a793e82d779b.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f6c0e-ebc4-722e-84c8-7262a774ec77.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of the apartment building with landscaping",
        "public_id": "019f6c0e-ebc4-722e-84c8-7262a774ec77",
        "storage_key": "property/5641831400341504/019f6c0e-ebc4-722e-84c8-7262a774ec77.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Fairways at Feather Sound | Apartments For Rent Near Me with Dog Park",
      "seo_description": "Find apartments for rent near me with dog park at Fairways at Feather Sound. Enjoy modern amenities, beautiful surroundings, and a prime Clearwater location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-me-modern-kitchen",
      "search_query": "Apartments For Rent Near Me with Kitchen",
      "category": "Amenity",
      "h1_title": "Discover Apartments For Rent Near Me with Modern Kitchen",
      "h2_subtitle": "Fairways at Feather Sound offers stylish apartments with sleek kitchens. Enjoy a vibrant community with beautiful surroundings and convenient access.",
      "page_copy": "Explore the perfect apartments for rent near me with kitchen at Fairways at Feather Sound in Clearwater. Our community features modern kitchens equipped with high-end appliances, including a dishwasher, microwave, and refrigerator, ensuring a seamless cooking experience. The spacious one and two bedroom apartments also include in-home washers and dryers, providing a comfortable and convenient living environment. \n\nSurrounded by two private lakes, tropical gardens, and meandering trails, our pet-friendly community offers a serene environment for all residents. Conveniently located just off I-275, Fairways at Feather Sound provides easy access to Feather Sound Country Club, local dining, and shopping options. Experience the laid-back Florida lifestyle with our exceptional amenities, including a heated pool, fitness center, and sundeck, making it the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f6c0e-e1b6-77c5-be1c-a793e82d779b.webp",
      "featured_image_media": {
        "alt_text": "Living room with a grey sofa, modern floor lamp, coffee table, and dining area.",
        "public_id": "019f6c0e-e1b6-77c5-be1c-a793e82d779b",
        "storage_key": "property/5641831400341504/019f6c0e-e1b6-77c5-be1c-a793e82d779b.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f6c0e-ebc4-722e-84c8-7262a774ec77.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of the apartment building with landscaping",
        "public_id": "019f6c0e-ebc4-722e-84c8-7262a774ec77",
        "storage_key": "property/5641831400341504/019f6c0e-ebc4-722e-84c8-7262a774ec77.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Fairways at Feather Sound | Apartments For Rent Near Me with Kitchen",
      "seo_description": "Find apartments for rent near me with kitchen at Fairways at Feather Sound. Enjoy modern amenities, beautiful surroundings, and a prime Clearwater location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5641831400341504",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-near-me-with-washer-dryer",
      "search_query": "Apartments For Rent Near Me with Washer/Dryer",
      "category": "Amenity",
      "h1_title": "Find Apartments For Rent Near Me with Washer/Dryer",
      "h2_subtitle": "Fairways at Feather Sound offers convenient apartments with in-home washer/dryer. Enjoy a vibrant community with beautiful surroundings and easy access.",
      "page_copy": "Discover the ideal apartments for rent near me with washer/dryer at Fairways at Feather Sound in Clearwater. Our community features in-home washers and dryers, providing the ultimate convenience for your laundry needs. The spacious one and two bedroom apartments also include modern kitchens and walk-in closets, ensuring a comfortable and organized living experience. \n\nNestled around two private lakes with tropical gardens and meandering trails, our pet-friendly community offers a serene environment for all residents. Located just off I-275, Fairways at Feather Sound provides easy access to Feather Sound Country Club, local dining, and shopping options. Experience the laid-back Florida lifestyle with our exceptional amenities, including a heated pool, fitness center, and sundeck, making it the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f6c0e-e1b6-77c5-be1c-a793e82d779b.webp",
      "featured_image_media": {
        "alt_text": "Living room with a grey sofa, modern floor lamp, coffee table, and dining area.",
        "public_id": "019f6c0e-e1b6-77c5-be1c-a793e82d779b",
        "storage_key": "property/5641831400341504/019f6c0e-e1b6-77c5-be1c-a793e82d779b.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5641831400341504/019f6c0e-ebc4-722e-84c8-7262a774ec77.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of the apartment building with landscaping",
        "public_id": "019f6c0e-ebc4-722e-84c8-7262a774ec77",
        "storage_key": "property/5641831400341504/019f6c0e-ebc4-722e-84c8-7262a774ec77.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "Fairways at Feather Sound | Apartments For Rent Near Me with Washer/Dryer",
      "seo_description": "Explore Fairways at Feather Sound for apartments for rent near me with washer/dryer. Enjoy modern amenities, beautiful surroundings, and a convenient Clearwater location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2161"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2376471122"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a2f\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a2f\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4680436"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-N7L3VHF"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "2"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_betterbot_script",
      "type": "STRING",
      "value": "<script src=\"https://fairwaysat2.engine.betterbot.com/loader.js\" defer=\"defer\"></script>"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8443889464"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/m9pzy89zvk1"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/6f3bc73e-6faa-4416-8ffd-261b50fe104a"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "727-626-5069"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Ik5pekd2TkpwQVdQZCs1UTllV2tDbFE9PSIsInZhbHVlIjoiSS9LVFRodTlwVWZNaEg0QnhiK3FWZz09IiwibWFjIjoiM2RlMjJlZWRlNjkxODVkMmNlNjZjNDAzYmIzNjAyY2QzZDg0NmIxNTUwZmUzNjViOWJjYThkNDU2MzkzYjI1YSJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2161",
  "custom_repli_id": "2376471122",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a2f\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a2f\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4680436",
  "custom_google_gtm_id": "GTM-N7L3VHF",
  "custom_rollout_phase": "2",
  "custom_ads_subscription": "full_stack",
  "custom_betterbot_script": "<script src=\"https://fairwaysat2.engine.betterbot.com/loader.js\" defer=\"defer\"></script>",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8443889464",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/m9pzy89zvk1",
  "custom_self_guided_tour_url": "https://selftournow.com/property/6f3bc73e-6faa-4416-8ffd-261b50fe104a",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "727-626-5069",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Ik5pekd2TkpwQVdQZCs1UTllV2tDbFE9PSIsInZhbHVlIjoiSS9LVFRodTlwVWZNaEg0QnhiK3FWZz09IiwibWFjIjoiM2RlMjJlZWRlNjkxODVkMmNlNjZjNDAzYmIzNjAyY2QzZDg0NmIxNTUwZmUzNjViOWJjYThkNDU2MzkzYjI1YSJ9",
  "custom_household_income_qualification_multiplier": "3"
};

export const generatedAt = '2026-10-09T16:39:00.434Z';
